<template>
  <div class="home">
    <!-- Hero Section -->
    <HeroSection />

    <!-- Unified Background Container for All Sections -->
    <div class="unified-background-container">
      <!-- Enhanced Futuristic Background Layer -->
      <div class="futuristic-background-layer">
        <!-- Animated Grid Pattern -->
        <div class="grid-pattern"></div>

        <!-- Flowing Light Streams -->
        <div class="light-stream stream-1"></div>
        <div class="light-stream stream-2"></div>
        <div class="light-stream stream-3"></div>

        <!-- Particle System -->
        <div class="particle-field">
          <div class="particle particle-1"></div>
          <div class="particle particle-2"></div>
          <div class="particle particle-3"></div>
          <div class="particle particle-4"></div>
          <div class="particle particle-5"></div>
          <div class="particle particle-6"></div>
        </div>

        <!-- Enhanced Geometric Shapes -->
        <div class="neo-shape neo-hexagon"></div>
        <div class="neo-shape neo-triangle"></div>
        <div class="neo-shape neo-circle"></div>

        <!-- Gradient Orbs -->
        <div class="gradient-orb orb-1"></div>
        <div class="gradient-orb orb-2"></div>
        <div class="gradient-orb orb-3"></div>

        <!-- Broken Glass/Crystal Structures -->
        <div class="glass-fragments">
          <div class="glass-shard shard-1"></div>
          <div class="glass-shard shard-2"></div>
          <div class="glass-shard shard-3"></div>
          <div class="glass-shard shard-4"></div>
          <div class="glass-shard shard-5"></div>
          <div class="glass-shard shard-6"></div>
        </div>

        <!-- Crystal Network -->
        <div class="crystal-network">
          <div class="crystal-node node-1"></div>
          <div class="crystal-node node-2"></div>
          <div class="crystal-node node-3"></div>
          <div class="crystal-node node-4"></div>
          <div class="crystal-connection connection-1"></div>
          <div class="crystal-connection connection-2"></div>
          <div class="crystal-connection connection-3"></div>
        </div>

        <!-- Awesome Geometric Elements -->
        <div class="geometric-awesome">
          <div class="diamond-shape diamond-1"></div>
          <div class="diamond-shape diamond-2"></div>
          <div class="rhombus-grid"></div>
          <div class="hologram-ring ring-1"></div>
          <div class="hologram-ring ring-2"></div>
          <div class="energy-wave wave-1"></div>
          <div class="energy-wave wave-2"></div>
        </div>

        <!-- AFRICA RISING: Dynamic Continental Story -->
        <div class="africa-transformation-system">
          <!-- Floating Africa Emblems -->
          <!-- <div class="africa-emblems">
            <div class="africa-emblem emblem-1">
              <img
                src="@/assets/images/africa image.png"
                alt="Africa Summit Vision"
                class="emblem-image"
              />
            </div>
            <div class="africa-emblem emblem-2">
              <img
                src="@/assets/images/Africa with words.png"
                alt="Africa Transformation"
                class="emblem-image"
              />
            </div>
          </div> -->

          <!-- 54 Nations Unity Stars - Scattered Dynamically -->
          <div class="unity-constellation">
            <div class="nation-cluster cluster-1">
              <div class="nation-star star-1"></div>
              <div class="nation-star star-2"></div>
              <div class="nation-star star-3"></div>
              <div class="nation-star star-4"></div>
              <div class="nation-star star-5"></div>
              <div class="connecting-bonds">
                <div class="bond bond-1"></div>
                <div class="bond bond-2"></div>
                <div class="bond bond-3"></div>
              </div>
            </div>

            <div class="nation-cluster cluster-2">
              <div class="nation-star star-6"></div>
              <div class="nation-star star-7"></div>
              <div class="nation-star star-8"></div>
              <div class="nation-star star-9"></div>
              <div class="connecting-bonds">
                <div class="bond bond-4"></div>
                <div class="bond bond-5"></div>
              </div>
            </div>

            <div class="nation-cluster cluster-3">
              <div class="nation-star star-10"></div>
              <div class="nation-star star-11"></div>
              <div class="nation-star star-12"></div>
              <div class="nation-star star-13"></div>
              <div class="nation-star star-14"></div>
              <div class="connecting-bonds">
                <div class="bond bond-6"></div>
                <div class="bond bond-7"></div>
              </div>
            </div>

            <div class="nation-cluster cluster-4">
              <div class="nation-star star-15"></div>
              <div class="nation-star star-16"></div>
              <div class="nation-star star-17"></div>
              <div class="connecting-bonds">
                <div class="bond bond-8"></div>
              </div>
            </div>
          </div>

          <!-- Dynamic Transformation Symbols -->
          <div class="transformation-symbols">
            <!-- Growth Trees -->
            <div class="growth-symbol symbol-tree-1">
              <div class="tree-trunk"></div>
              <div class="tree-leaves">
                <div class="leaf leaf-1"></div>
                <div class="leaf leaf-2"></div>
                <div class="leaf leaf-3"></div>
              </div>
            </div>

            <div class="growth-symbol symbol-tree-2">
              <div class="tree-trunk"></div>
              <div class="tree-leaves">
                <div class="leaf leaf-1"></div>
                <div class="leaf leaf-2"></div>
              </div>
            </div>

            <!-- Innovation Lightbulbs -->
            <div class="innovation-symbol bulb-1">
              <div class="bulb-glow"></div>
              <div class="innovation-sparks">
                <div class="spark spark-1"></div>
                <div class="spark spark-2"></div>
                <div class="spark spark-3"></div>
              </div>
            </div>

            <div class="innovation-symbol bulb-2">
              <div class="bulb-glow"></div>
              <div class="innovation-sparks">
                <div class="spark spark-1"></div>
                <div class="spark spark-2"></div>
              </div>
            </div>

            <!-- Leadership Crowns -->
            <div class="leadership-symbol crown-1">
              <div class="crown-peaks">
                <div class="peak peak-1"></div>
                <div class="peak peak-2"></div>
                <div class="peak peak-3"></div>
              </div>
              <div class="crown-glow"></div>
            </div>

            <!-- Collaboration Circles -->
            <div class="collaboration-symbol circle-1">
              <div class="collab-ring ring-outer"></div>
              <div class="collab-ring ring-middle"></div>
              <div class="collab-ring ring-inner"></div>
              <div class="connection-lines">
                <div class="line line-1"></div>
                <div class="line line-2"></div>
                <div class="line line-3"></div>
              </div>
            </div>

            <div class="collaboration-symbol circle-2">
              <div class="collab-ring ring-outer"></div>
              <div class="collab-ring ring-middle"></div>
              <div class="connection-lines">
                <div class="line line-1"></div>
                <div class="line line-2"></div>
              </div>
            </div>
          </div>

          <!-- Continental Energy Flow -->
          <svg
            class="continental-energy"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
          >
            <!-- Energy Rivers -->
            <path
              class="energy-river river-1"
              d="M10,20 Q30,25 50,30 Q70,35 90,40"
            />
            <path
              class="energy-river river-2"
              d="M15,60 Q35,55 55,50 Q75,45 95,40"
            />
            <path
              class="energy-river river-3"
              d="M5,80 Q25,75 45,70 Q65,65 85,60"
            />

            <!-- Transformation Waves -->
            <path
              class="transformation-wave"
              d="M0,50 Q20,45 40,50 Q60,55 80,50 Q90,48 100,50"
            />
          </svg>

          <!-- Future Vision Beacons -->
          <div class="vision-beacons">
            <div class="beacon beacon-arusha">
              <div class="beacon-light"></div>
              <div class="beacon-pulse pulse-1"></div>
              <div class="beacon-pulse pulse-2"></div>
              <!-- <div class="beacon-label">Arusha 2026</div> -->
            </div>

            <div class="beacon beacon-future">
              <div class="beacon-light"></div>
              <div class="beacon-pulse pulse-1 p-5 h-13"></div>
              <!-- <div class="beacon-label">Future Ready</div> -->
            </div>

            <!-- <div class="beacon beacon-unity">
              <div class="beacon-light"></div>
              <div class="beacon-pulse pulse-1"></div>
              <div class="beacon-label">54 Nations</div>
            </div> -->
          </div>

          <!-- Growth & Transformation Trees -->
          <div class="transformation-trees">
            <div class="growth-tree tree-1">
              <div class="tree-trunk"></div>
              <div class="tree-branches">
                <div class="branch branch-1"></div>
                <div class="branch branch-2"></div>
                <div class="branch branch-3"></div>
                <div class="branch branch-4"></div>
              </div>
              <div class="growth-leaves">
                <div class="leaf leaf-1"></div>
                <div class="leaf leaf-2"></div>
                <div class="leaf leaf-3"></div>
                <div class="leaf leaf-4"></div>
                <div class="leaf leaf-5"></div>
              </div>
            </div>
            <div class="growth-tree tree-2">
              <div class="tree-trunk"></div>
              <div class="tree-branches">
                <div class="branch branch-1"></div>
                <div class="branch branch-2"></div>
                <div class="branch branch-3"></div>
              </div>
              <div class="growth-leaves">
                <div class="leaf leaf-1"></div>
                <div class="leaf leaf-2"></div>
                <div class="leaf leaf-3"></div>
              </div>
            </div>
          </div>

          <!-- Human Potential Rising Elements -->
          <div class="human-potential-system">
            <div class="rising-figure figure-1">
              <div class="figure-body"></div>
              <div class="potential-aura"></div>
              <div class="skills-emanation">
                <div class="skill-particle skill-1"></div>
                <div class="skill-particle skill-2"></div>
                <div class="skill-particle skill-3"></div>
              </div>
            </div>
            <div class="rising-figure figure-2">
              <div class="figure-body"></div>
              <div class="potential-aura"></div>
              <div class="skills-emanation">
                <div class="skill-particle skill-1"></div>
                <div class="skill-particle skill-2"></div>
              </div>
            </div>
          </div>

          <!-- Continental Bridge Networks -->
          <svg
            class="continental-bridges"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
          >
            <!-- Unity Bridges connecting across Africa -->
            <path
              class="unity-bridge bridge-primary"
              d="M10,20 Q30,15 50,20 Q70,25 90,20"
            />
            <path
              class="unity-bridge bridge-secondary"
              d="M5,40 Q25,35 45,40 Q65,45 85,40"
            />
            <path
              class="unity-bridge bridge-tertiary"
              d="M15,60 Q35,55 55,60 Q75,65 95,60"
            />
            <path
              class="unity-bridge bridge-quaternary"
              d="M8,80 Q28,75 48,80 Q68,85 88,80"
            />

            <!-- Transformation Waves -->
            <path
              class="transformation-wave wave-growth"
              d="M0,30 Q20,25 40,30 Q60,35 80,30 Q90,28 100,30"
            />
            <path
              class="transformation-wave wave-innovation"
              d="M0,50 Q25,45 50,50 Q75,55 100,50"
            />
            <path
              class="transformation-wave wave-future"
              d="M0,70 Q30,65 60,70 Q80,75 100,70"
            />
          </svg>

          <!-- Future Vision Portals -->
          <div class="future-vision-portals">
            <div class="vision-portal portal-1">
              <div class="portal-ring ring-outer"></div>
              <div class="portal-ring ring-middle"></div>
              <div class="portal-ring ring-inner"></div>
              <div class="portal-core"></div>
            </div>
            <div class="vision-portal portal-2">
              <div class="portal-ring ring-outer"></div>
              <div class="portal-ring ring-middle"></div>
              <div class="portal-core"></div>
            </div>
          </div>

          <!-- Workforce Innovation Spirals -->
          <div class="innovation-spirals">
            <div class="innovation-spiral spiral-1"></div>
            <div class="innovation-spiral spiral-2"></div>
            <div class="innovation-spiral spiral-3"></div>
          </div>

          <!-- Leadership Excellence Beacons -->
          <div class="leadership-beacons">
            <div class="beacon beacon-1">
              <div class="beacon-light"></div>
              <div class="beacon-pulse pulse-1"></div>
              <div class="beacon-pulse pulse-2"></div>
            </div>
            <div class="beacon beacon-2">
              <div class="beacon-light"></div>
              <div class="beacon-pulse pulse-1"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Original Geometric Overlay (Enhanced) -->
      <div class="geometric-overlay">
        <div class="floating-shape shape-1"></div>
        <div class="floating-shape shape-2"></div>
        <div class="floating-shape shape-3"></div>
        <div class="floating-shape shape-4"></div>
      </div>

      <!-- About Section (redesigned) -->
      <section class="about-section ahrs-about full-width" id="about">
        <div class="ahrs-about-wrap">
          <!-- Header -->
          <div class="ahrs-about-header" data-aos="fade-up">
            <div class="ahrs-about-eyebrow">
              <span class="dot"></span>About the Event
            </div>
            <h2 class="ahrs-about-title">
              A pan-African gathering on
              <span class="ahrs-about-italic">the future of work.</span>
            </h2>
          </div>

          <!-- Body grid -->
          <div class="ahrs-about-body">
            <!-- Left column: lede + theme -->
            <div class="ahrs-about-lede-col" data-aos="fade-up" data-aos-delay="100">
              <div class="ahrs-about-summit-line">
                <span class="ahrs-about-summit-name"
                  >Africa Human Resource Summit</span
                >
                <span class="ahrs-about-summit-acro">AHRS</span>
              </div>

              <p class="ahrs-about-lede">
                The premier pan-African platform dedicated to shaping the future
                of work across the continent. Bringing together leaders,
                policymakers, and HR professionals from
                <strong>54 African nations</strong> to strengthen human capital
                and drive workforce innovation.
              </p>

              <div class="ahrs-about-theme-card">
                <div class="ahrs-about-theme-label">2026 Theme</div>
                <p class="ahrs-about-theme-quote">
                  &ldquo;Transforming Africa&rsquo;s Workforce for the
                  Future&rdquo;
                </p>
              </div>
            </div>

            <!-- Right column: event details -->
            <aside
              class="ahrs-about-details"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div class="ahrs-about-details-head">Event Details</div>
              <dl class="ahrs-about-detail-list">
                <div class="ahrs-about-detail">
                  <div class="ahrs-about-detail-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.8"
                      stroke-linecap="round"
                    >
                      <rect x="3" y="4.5" width="18" height="17" rx="2" />
                      <path d="M3 9h18M8 2.5v4M16 2.5v4" />
                    </svg>
                  </div>
                  <div>
                    <dt>Date</dt>
                    <dd>19 &ndash; 22 August 2026</dd>
                  </div>
                </div>

                <div class="ahrs-about-detail">
                  <div class="ahrs-about-detail-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.8"
                      stroke-linecap="round"
                    >
                      <path
                        d="M12 21s7-5.6 7-11a7 7 0 1 0-14 0c0 5.4 7 11 7 11Z"
                      />
                      <circle cx="12" cy="10" r="2.6" />
                    </svg>
                  </div>
                  <div>
                    <dt>Venue</dt>
                    <dd>Mount Meru Hotel<br />Arusha, Tanzania</dd>
                  </div>
                </div>

                <div class="ahrs-about-detail">
                  <div class="ahrs-about-detail-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.8"
                      stroke-linecap="round"
                    >
                      <circle cx="12" cy="12" r="9" />
                      <path d="M3 12h18" />
                      <path
                        d="M12 3a14 14 0 0 1 4 9 14 14 0 0 1-4 9 14 14 0 0 1-4-9 14 14 0 0 1 4-9z"
                      />
                    </svg>
                  </div>
                  <div>
                    <dt>Scope</dt>
                    <dd>54 African Nations</dd>
                  </div>
                </div>
              </dl>
            </aside>
          </div>

          <!-- Stat strip -->
          <div
            class="ahrs-about-stats"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <div class="ahrs-about-stat">
              <span class="ahrs-about-stat-n">54</span>
              <span class="ahrs-about-stat-l">African Nations</span>
            </div>
            <div class="ahrs-about-stat">
              <span class="ahrs-about-stat-n">4</span>
              <span class="ahrs-about-stat-l">Days of Programme</span>
            </div>
            <div class="ahrs-about-stat">
              <span class="ahrs-about-stat-n">2026</span>
              <span class="ahrs-about-stat-l">Future-Ready</span>
            </div>
            <div class="ahrs-about-stat">
              <span class="ahrs-about-stat-n">&infin;</span>
              <span class="ahrs-about-stat-l">Possibilities</span>
            </div>
          </div>

          <!-- THRAPA Events -->
          <!-- <div class="thrapa-events" data-aos="fade-up" data-aos-delay="700">
            <div class="thrapa-events-label">Hosted by THRAPA</div>
            <div class="thrapa-events-chips">
              <span class="event-chip">Annual National Conference — 2025</span>
              <span class="event-chip">International Digital Workplace Summit — 2025</span>
              <span class="event-chip event-chip-upcoming">International Digital Workplace Summit — 2026</span>
            </div>
          </div> -->
        </div>
      </section>

      <!-- Key Objectives Section -->
      <section
        class="objectives-section ahrs-editorial full-width"
        style="background: var(--gradient-alt)"
      >
        <div class="container-wide">
          <div class="ahrs-section-header" data-aos="fade-up">
            <div class="ahrs-section-eyebrow">
              <span class="dot"></span>Key Objectives
            </div>
            <h2 class="ahrs-section-title">
              What this summit will
              <span class="ahrs-section-italic">deliver.</span>
            </h2>
          </div>
          <div class="objectives-grid">
            <div
              class="objective-card"
              data-aos="flip-left"
              data-aos-delay="100"
            >
              <div class="objective-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  class="creative-icon"
                >
                  <path
                    d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                  />
                  <path d="M8 9h8" />
                  <path d="M8 13h6" />
                </svg>
              </div>
              <h3 class="objective-title">High-Level Dialogue</h3>
              <p class="objective-text">
                Enable High-Level Dialogue on HR Transformation and Workforce
                Futures
              </p>
            </div>
            <div
              class="objective-card"
              data-aos="flip-left"
              data-aos-delay="200"
            >
              <div class="objective-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  class="creative-icon"
                >
                  <path d="M9 12l2 2 4-4" />
                  <path
                    d="M21 12c.552 0 1-.448 1-1V5c0-.552-.448-1-1-1H3c-.552 0-1 .448-1 1v6c0 .552.448 1 1 1"
                  />
                  <path d="M3 12v7c0 .552.448 1 1 1h16c.552 0 1-.448 1-1v-7" />
                  <circle cx="12" cy="8" r="3" />
                </svg>
              </div>
              <h3 class="objective-title">Innovation</h3>
              <p class="objective-text">
                Promote Innovative HR Practices for Inclusive Growth and
                Competitiveness
              </p>
            </div>
            <div
              class="objective-card"
              data-aos="flip-left"
              data-aos-delay="300"
            >
              <div class="objective-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  class="creative-icon"
                >
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
              <h3 class="objective-title">Collaboration</h3>
              <p class="objective-text">
                Strengthen Regional Collaboration and Professional HR Networks
              </p>
            </div>
            <div
              class="objective-card"
              data-aos="flip-left"
              data-aos-delay="400"
            >
              <div class="objective-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  class="creative-icon"
                >
                  <polygon points="13,2 3,14 12,14 11,22 21,10 12,10" />
                </svg>
              </div>
              <h3 class="objective-title">Strategic Action</h3>
              <p class="objective-text">
                Drive Strategic Action on Youth Employment, Reskilling and
                Gender Equity
              </p>
            </div>
            <div
              class="objective-card"
              data-aos="flip-left"
              data-aos-delay="500"
            >
              <div class="objective-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  class="creative-icon"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M2 12h20" />
                  <path
                    d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
                  />
                </svg>
              </div>
              <h3 class="objective-title">Global Leadership</h3>
              <p class="objective-text">
                Position Africa as a Global Leader in the Future of Work
              </p>
            </div>
          </div>
          <div class="impact-section">
            <h4 class="impact-title">Expected Summit Impact</h4>
            <p class="impact-text">
              Join us in creating a lasting impact on Africa's workforce
              landscape. Together, we'll develop actionable strategies for
              talent development, establish cross-border partnerships, and
              position Africa as a global leader in innovative HR practices.
              This summit represents a pivotal moment for shaping the
              continent's economic future through strategic human capital
              development.
            </p>
          </div>
        </div>
      </section>

      <!-- Themes Section -->
      <section
        class="themes-section ahrs-editorial full-width"
        id="themes"
        style="background: var(--color-background-light)"
      >
        <div class="container-wide">
          <div class="ahrs-section-header" data-aos="fade-up">
            <div class="ahrs-section-eyebrow">
              <span class="dot"></span>Summit Themes
            </div>
            <h2 class="ahrs-section-title">
              Four focus areas shaping
              <span class="ahrs-section-italic">the future of work.</span>
            </h2>
            <p class="ahrs-section-lede" data-aos="fade-up" data-aos-delay="100">
              Key thematic areas the summit will explore to transform Africa&rsquo;s
              workforce.
            </p>
          </div>

          <div class="themes-grid" data-aos="fade-up" data-aos-delay="200">
            <div class="theme-card" data-aos="fade-up" data-aos-delay="300">
              <h3>Digital Transformation and Workforce Innovation</h3>
              <p>
                Exploring how digital technologies and innovative approaches are
                revolutionizing HR practices across Africa, from AI-powered
                recruitment to digital learning platforms and remote work
                solutions.
              </p>
              <div class="theme-highlights">
                <span class="highlight">AI in HR</span>
                <span class="highlight">Digital Learning</span>
                <span class="highlight">Workforce Analytics</span>
              </div>
            </div>

            <div class="theme-card" data-aos="fade-up" data-aos-delay="400">
              <h3>Ethics and Governance of Artificial Intelligence (AI)</h3>
              <p>
                Examining the ethical frameworks and governance structures
                needed for responsible AI deployment in HR, addressing bias,
                transparency, accountability, and human dignity in AI-driven
                workplaces.
              </p>
              <div class="theme-highlights">
                <span class="highlight">AI Ethics</span>
                <span class="highlight">Responsible AI</span>
                <span class="highlight">AI Governance</span>
              </div>
            </div>

            <div class="theme-card" data-aos="fade-up" data-aos-delay="500">
              <h3>Talent Acquisition &amp; Retention in Competitive Markets</h3>
              <p>
                Strategies for attracting, developing, and retaining top talent
                across Africa's diverse and increasingly competitive labour
                markets, leveraging employer branding and employee value
                propositions.
              </p>
              <div class="theme-highlights">
                <span class="highlight">Talent Strategy</span>
                <span class="highlight">Employer Branding</span>
                <span class="highlight">Employee Retention</span>
              </div>
            </div>

            <div class="theme-card" data-aos="fade-up" data-aos-delay="600">
              <h3>Prioritizing Mental Health and Well-Being at Work</h3>
              <p>
                Prioritizing employee mental health and wellbeing as a critical
                component of organizational success, exploring strategies for
                creating psychologically safe and supportive work environments.
              </p>
              <div class="theme-highlights">
                <span class="highlight">Mental Wellness</span>
                <span class="highlight">Psychological Safety</span>
                <span class="highlight">Work-Life Balance</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Past AHRS Gallery Section -->
      <PastAhrsGallery />

      <!-- Partners & Supporters Section -->
      <section class="partners-section ahrs-editorial full-width" id="partners" style="background: var(--gradient-section)">
        <div class="container-wide">
          <div class="ahrs-section-header" data-aos="fade-up">
            <div class="ahrs-section-eyebrow">
              <span class="dot"></span>Partners &amp; Supporters
            </div>
            <h2 class="ahrs-section-title">
              Endorsed by
              <span class="ahrs-section-italic">21+ partner associations.</span>
            </h2>
            <p class="ahrs-section-lede" data-aos="fade-up" data-aos-delay="100">
              AHRS 2026 is supported by leading HR associations, professional
              bodies, and government institutions from across Africa and
              beyond.
            </p>
          </div>
          <div class="partners-teaser" data-aos="fade-up" data-aos-delay="200">
            <p class="partners-count">20+ partner organisations spanning 15+ African nations and international bodies</p>
            <router-link to="/partners" class="btn-partners">
              View All Partners
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14M13 6l6 6-6 6" />
              </svg>
            </router-link>
          </div>
        </div>
      </section>

      <!-- Pricing Section -->
      <section
        class="pricing-section ahrs-editorial full-width"
        id="pricing"
        style="background: var(--gradient-section)"
      >
        <div class="container-wide">
          <div class="ahrs-section-header" data-aos="fade-up">
            <div class="ahrs-section-eyebrow">
              <span class="dot"></span>Registration
            </div>
            <h2 class="ahrs-section-title">
              Choose your
              <span class="ahrs-section-italic">delegate category.</span>
            </h2>
            <p class="ahrs-section-lede" data-aos="fade-up" data-aos-delay="100">
              Select the rate that applies to you for the AHRS 2026 programme.
            </p>
          </div>
          <div class="pricing-grid-simple">
            <!-- THRAPA Members -->
            <div
              class="pricing-card-simple"
              data-aos="flip-up"
              data-aos-delay="100"
            >
              <h3 class="pricing-title-simple">Tanzania Delegates</h3>
              <p class="pricing-subtitle-simple">Local</p>
              <div class="pricing-amount-simple">
                <div class="price-display">
                  <span class="currency-simple">TZS</span>
                  <span class="price-simple">1,000,000</span>
                </div>
                <span class="price-label">Participation</span>
              </div>
              <p class="pricing-description">
                Full 4-day summit access with all sessions and materials
              </p>

              <div class="additional-services">
                <div class="service-item">
                  <span>Masterclass</span>
                  <span class="service-price">TZS 250,000</span>
                </div>
                <div class="service-item">
                  <span>Tour</span>
                  <span class="service-price">TZS 200,000</span>
                </div>
              </div>

              <button class="btn-pricing-simple" @click="handleRegistration">
                REGISTER NOW
              </button>
            </div>

            <!-- EAHRF Members -->
            <div
              class="pricing-card-simple"
              data-aos="flip-up"
              data-aos-delay="200"
            >
              <h3 class="pricing-title-simple">East Africa Delegates</h3>
              <p class="pricing-subtitle-simple">Regional</p>
              <div class="pricing-amount-simple">
                <div class="price-display">
                  <span class="currency-simple">USD</span>
                  <span class="price-simple">500</span>
                </div>
                <span class="price-label">Participation</span>
              </div>
              <p class="pricing-description">
                Full 4-day summit access with all sessions and materials
              </p>

              <div class="additional-services">
                <div class="service-item">
                  <span>Masterclass</span>
                  <span class="service-price">USD 100</span>
                </div>
                <div class="service-item">
                  <span>Tour</span>
                  <span class="service-price">USD 200</span>
                </div>
              </div>

              <button class="btn-pricing-simple" @click="handleRegistration">
                REGISTER NOW
              </button>
            </div>

            <!-- AHRC Members -->
            <div
              class="pricing-card-simple featured"
              data-aos="flip-up"
              data-aos-delay="250"
            >
              <h3 class="pricing-title-simple">Africa Delegates</h3>
              <p class="pricing-subtitle-simple">Continent</p>
              <div class="pricing-amount-simple">
                <div class="price-display">
                  <span class="currency-simple">USD</span>
                  <span class="price-simple">700</span>
                </div>
                <span class="price-label">Participation</span>
              </div>
              <p class="pricing-description">
                Full 4-day summit access with all sessions and materials
              </p>

              <div class="additional-services">
                <div class="service-item">
                  <span>Masterclass</span>
                  <span class="service-price">USD 100</span>
                </div>
                <div class="service-item">
                  <span>Tour</span>
                  <span class="service-price">USD 300</span>
                </div>
              </div>

              <button class="btn-pricing-simple" @click="handleRegistration">
                REGISTER NOW
              </button>
            </div>

            <!-- International Members -->
            <div
              class="pricing-card-simple"
              data-aos="flip-up"
              data-aos-delay="350"
            >
              <h3 class="pricing-title-simple">International Delegates</h3>
              <p class="pricing-subtitle-simple">Global</p>
              <div class="pricing-amount-simple">
                <div class="price-display">
                  <span class="currency-simple">USD</span>
                  <span class="price-simple">900</span>
                </div>
                <span class="price-label">Participation</span>
              </div>
              <p class="pricing-description">
                Full 4-day summit access with all sessions and materials
              </p>

              <div class="additional-services">
                <div class="service-item">
                  <span>Masterclass</span>
                  <span class="service-price">USD 100</span>
                </div>
                <div class="service-item">
                  <span>Tour</span>
                  <span class="service-price">USD 300</span>
                </div>
              </div>

              <button class="btn-pricing-simple" @click="handleRegistration">
                REGISTER NOW
              </button>
            </div>
          </div>

          <!-- Additional Info -->
          <div class="pricing-info" data-aos="fade-up" data-aos-delay="400">
            <p class="pricing-note">
              For detailed pricing including tour packages and masterclasses,
              <router-link to="/registration" class="pricing-link"
                >view complete pricing</router-link
              >
            </p>
          </div>
        </div>
      </section>

    </div>
    <!-- End Unified Background Container -->
  </div>
</template>

<script>
import HeroSection from "@/components/HeroSection.vue";
import PastAhrsGallery from "@/components/PastAhrsGallery.vue";
export default {
  name: "HomeView",
  components: {
    HeroSection,
    PastAhrsGallery,
  },
  methods: {
    handleRegistration() {
      this.$router.push("/registration");
    },
    downloadAgenda() {
      // Add download functionality here
      alert("PDF download functionality to be implemented");
    },
    getCurrentDayData() {
      return this.agendaDays[this.selectedDay] || this.agendaDays[0];
    },
    getCurrentDayNumber() {
      return String(this.selectedDay).padStart(2, "0");
    },
    scrollToSection(sectionId) {
      // Handle home section - scroll to top
      if (sectionId === "home") {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        return;
      }

      // For other sections, scroll to the element
      this.smoothScrollToElement(sectionId);
    },
    smoothScrollToElement(sectionId) {
      setTimeout(() => {
        const element = document.querySelector(`.${sectionId}-section`);
        if (element) {
          const offsetTop = element.offsetTop - 100; // Account for fixed header
          window.scrollTo({
            top: offsetTop,
            behavior: "smooth",
          });
        }
      }, 100);
    },
  },
  mounted() {
  },
  beforeUnmount() {
  },
};
</script>

<style scoped>
/* ===== UNIFIED BACKGROUND SYSTEM ===== */
.unified-background-container {
  position: relative;
  background: linear-gradient(
    135deg,
    #ffffff 0%,
    #f8fffe 25%,
    #f0f8f0 50%,
    #f8fffe 75%,
    #ffffff 100%
  );
  overflow: hidden;
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0;
}

/* ===== FUTURISTIC BACKGROUND LAYER ===== */
.futuristic-background-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
  overflow: hidden;
  transform: translateZ(0);
  will-change: transform;
  backface-visibility: hidden;
}

/* Animated Grid Pattern */
.grid-pattern {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.05;
  background-image: linear-gradient(rgba(34, 139, 34, 0.3) 1px, transparent 1px),
    linear-gradient(90deg, rgba(34, 139, 34, 0.3) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: gridFlow 20s linear infinite;
}

@keyframes gridFlow {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(50px, 50px);
  }
}

/* Flowing Light Streams */
.light-stream {
  position: absolute;
  width: 2px;
  height: 100%;
  background: linear-gradient(
    to bottom,
    transparent 0%,
    rgba(74, 222, 128, 0.6) 20%,
    rgba(34, 197, 94, 0.8) 50%,
    rgba(74, 222, 128, 0.6) 80%,
    transparent 100%
  );
  border-radius: 1px;
  box-shadow: 0 0 10px rgba(74, 222, 128, 0.4);
}

.stream-1 {
  left: 20%;
  animation: streamFlow1 15s ease-in-out infinite;
}

.stream-2 {
  left: 60%;
  animation: streamFlow2 18s ease-in-out infinite reverse;
}

.stream-3 {
  left: 85%;
  animation: streamFlow3 12s ease-in-out infinite;
}

@keyframes streamFlow1 {
  0%,
  100% {
    opacity: 0.3;
    transform: scaleY(0.5);
  }
  50% {
    opacity: 0.8;
    transform: scaleY(1.2);
  }
}

@keyframes streamFlow2 {
  0%,
  100% {
    opacity: 0.2;
    transform: scaleY(0.8);
  }
  50% {
    opacity: 0.6;
    transform: scaleY(1.5);
  }
}

@keyframes streamFlow3 {
  0%,
  100% {
    opacity: 0.4;
    transform: scaleY(0.6);
  }
  50% {
    opacity: 0.7;
    transform: scaleY(1);
  }
}

/* Particle System */
.particle-field {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.particle {
  position: absolute;
  width: 4px;
  height: 4px;
  background: radial-gradient(
    circle,
    rgba(74, 222, 128, 0.8) 0%,
    transparent 70%
  );
  border-radius: 50%;
  box-shadow: 0 0 6px rgba(74, 222, 128, 0.5);
}

.particle-1 {
  top: 20%;
  left: 10%;
  animation: particleFloat1 25s ease-in-out infinite;
}

.particle-2 {
  top: 60%;
  left: 30%;
  animation: particleFloat2 30s ease-in-out infinite;
}

.particle-3 {
  top: 80%;
  left: 70%;
  animation: particleFloat3 20s ease-in-out infinite;
}

.particle-4 {
  top: 40%;
  left: 80%;
  animation: particleFloat1 35s ease-in-out infinite reverse;
}

.particle-5 {
  top: 10%;
  left: 50%;
  animation: particleFloat2 28s ease-in-out infinite reverse;
}

.particle-6 {
  top: 90%;
  left: 20%;
  animation: particleFloat3 22s ease-in-out infinite;
}

@keyframes particleFloat1 {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.4;
  }
  25% {
    transform: translate(30px, -20px) scale(1.2);
    opacity: 0.8;
  }
  50% {
    transform: translate(-20px, -40px) scale(0.8);
    opacity: 0.6;
  }
  75% {
    transform: translate(40px, -10px) scale(1.1);
    opacity: 0.7;
  }
}

@keyframes particleFloat2 {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.3;
  }
  33% {
    transform: translate(-25px, 30px) scale(1.3);
    opacity: 0.9;
  }
  66% {
    transform: translate(35px, -25px) scale(0.9);
    opacity: 0.5;
  }
}

@keyframes particleFloat3 {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.5;
  }
  50% {
    transform: translate(-15px, 25px) scale(1.1);
    opacity: 0.8;
  }
}

/* Neo Geometric Shapes */
.neo-shape {
  position: absolute;
  border: 2px solid rgba(74, 222, 128, 0.3);
  background: radial-gradient(
    circle,
    rgba(74, 222, 128, 0.1) 0%,
    transparent 70%
  );
  backdrop-filter: blur(5px);
}

.neo-hexagon {
  width: 80px;
  height: 80px;
  top: 15%;
  right: 15%;
  clip-path: polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);
  animation: neoRotate 20s linear infinite;
}

.neo-triangle {
  width: 60px;
  height: 60px;
  top: 70%;
  left: 5%;
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  animation: neoFloat 15s ease-in-out infinite;
}

.neo-circle {
  width: 100px;
  height: 100px;
  top: 45%;
  right: 5%;
  border-radius: 50%;
  animation: neoPulse 12s ease-in-out infinite;
}

@keyframes neoRotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes neoFloat {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

@keyframes neoPulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.4;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.7;
  }
}

/* Gradient Orbs */
.gradient-orb {
  position: absolute;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(74, 222, 128, 0.15) 0%,
    rgba(34, 197, 94, 0.1) 40%,
    transparent 70%
  );
  filter: blur(20px);
}

.orb-1 {
  width: 200px;
  height: 200px;
  top: 10%;
  left: 5%;
  animation: orbFloat1 25s ease-in-out infinite;
}

.orb-2 {
  width: 150px;
  height: 150px;
  top: 60%;
  right: 10%;
  animation: orbFloat2 30s ease-in-out infinite reverse;
}

.orb-3 {
  width: 120px;
  height: 120px;
  bottom: 20%;
  left: 50%;
  animation: orbFloat3 20s ease-in-out infinite;
}

@keyframes orbFloat1 {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }
  25% {
    transform: translate(50px, -30px) scale(1.1);
  }
  50% {
    transform: translate(-30px, -50px) scale(0.9);
  }
  75% {
    transform: translate(40px, -20px) scale(1.05);
  }
}

@keyframes orbFloat2 {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(-40px, 20px) scale(1.2);
  }
  66% {
    transform: translate(30px, -40px) scale(0.8);
  }
}

@keyframes orbFloat3 {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(-20px, 30px) scale(1.15);
  }
}

/* ===== BROKEN GLASS/CRYSTAL STRUCTURES ===== */
.glass-fragments {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.glass-shard {
  position: absolute;
  background: linear-gradient(
    135deg,
    rgba(74, 222, 128, 0.08) 0%,
    rgba(34, 197, 94, 0.12) 50%,
    rgba(74, 222, 128, 0.06) 100%
  );
  border: 1px solid rgba(74, 222, 128, 0.2);
  backdrop-filter: blur(8px);
  box-shadow: 0 0 15px rgba(74, 222, 128, 0.1),
    inset 0 0 15px rgba(255, 255, 255, 0.1);
}

.shard-1 {
  width: 80px;
  height: 120px;
  top: 25%;
  left: 15%;
  clip-path: polygon(
    30% 0%,
    70% 0%,
    100% 30%,
    80% 70%,
    60% 100%,
    20% 80%,
    0% 40%
  );
  animation: shardFloat1 18s ease-in-out infinite;
}

.shard-2 {
  width: 60px;
  height: 90px;
  top: 65%;
  right: 20%;
  clip-path: polygon(50% 0%, 90% 35%, 75% 70%, 50% 100%, 25% 70%, 10% 35%);
  animation: shardFloat2 22s ease-in-out infinite;
}

.shard-3 {
  width: 100px;
  height: 70px;
  top: 10%;
  right: 30%;
  clip-path: polygon(0% 20%, 60% 0%, 100% 40%, 80% 100%, 20% 80%);
  animation: shardFloat3 16s ease-in-out infinite;
}

.shard-4 {
  width: 70px;
  height: 110px;
  bottom: 15%;
  left: 8%;
  clip-path: polygon(40% 0%, 80% 20%, 100% 60%, 60% 100%, 20% 80%, 0% 40%);
  animation: shardFloat1 20s ease-in-out infinite reverse;
}

.shard-5 {
  width: 90px;
  height: 60px;
  top: 45%;
  left: 45%;
  clip-path: polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);
  animation: shardFloat2 24s ease-in-out infinite reverse;
}

.shard-6 {
  width: 50px;
  height: 80px;
  bottom: 35%;
  right: 15%;
  clip-path: polygon(50% 0%, 100% 25%, 82% 75%, 50% 100%, 18% 75%, 0% 25%);
  animation: shardFloat3 14s ease-in-out infinite;
}

@keyframes shardFloat1 {
  0%,
  100% {
    transform: translate(0, 0) rotate(0deg);
    opacity: 0.6;
  }
  25% {
    transform: translate(15px, -10px) rotate(5deg);
    opacity: 0.8;
  }
  50% {
    transform: translate(-10px, -20px) rotate(-3deg);
    opacity: 0.7;
  }
  75% {
    transform: translate(20px, -5px) rotate(8deg);
    opacity: 0.9;
  }
}

@keyframes shardFloat2 {
  0%,
  100% {
    transform: translate(0, 0) rotate(0deg);
    opacity: 0.5;
  }
  33% {
    transform: translate(-20px, 15px) rotate(-8deg);
    opacity: 0.8;
  }
  66% {
    transform: translate(25px, -15px) rotate(6deg);
    opacity: 0.6;
  }
}

@keyframes shardFloat3 {
  0%,
  100% {
    transform: translate(0, 0) rotate(0deg);
    opacity: 0.7;
  }
  50% {
    transform: translate(-15px, 20px) rotate(-5deg);
    opacity: 0.9;
  }
}

/* ===== CRYSTAL NETWORK ===== */
.crystal-network {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.crystal-node {
  position: absolute;
  width: 12px;
  height: 12px;
  background: radial-gradient(
    circle,
    rgba(74, 222, 128, 0.9) 0%,
    rgba(34, 197, 94, 0.6) 100%
  );
  border-radius: 50%;
  box-shadow: 0 0 20px rgba(74, 222, 128, 0.6),
    inset 0 0 8px rgba(255, 255, 255, 0.3);
  animation: nodePulse 3s ease-in-out infinite;
}

.node-1 {
  top: 30%;
  left: 25%;
  animation-delay: 0s;
}

.node-2 {
  top: 20%;
  left: 65%;
  animation-delay: 0.5s;
}

.node-3 {
  top: 70%;
  left: 40%;
  animation-delay: 1s;
}

.node-4 {
  bottom: 25%;
  right: 25%;
  animation-delay: 1.5s;
}

@keyframes nodePulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.6;
  }
  50% {
    transform: scale(1.5);
    opacity: 1;
  }
}

.crystal-connection {
  position: absolute;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(74, 222, 128, 0.4) 20%,
    rgba(34, 197, 94, 0.6) 50%,
    rgba(74, 222, 128, 0.4) 80%,
    transparent 100%
  );
  box-shadow: 0 0 8px rgba(74, 222, 128, 0.3);
}

.connection-1 {
  top: 25%;
  left: 25%;
  width: 40%;
  transform: rotate(15deg);
  animation: connectionFlow1 4s ease-in-out infinite;
}

.connection-2 {
  top: 30%;
  left: 40%;
  width: 30%;
  transform: rotate(-45deg);
  animation: connectionFlow2 5s ease-in-out infinite;
}

.connection-3 {
  bottom: 25%;
  left: 40%;
  width: 35%;
  transform: rotate(25deg);
  animation: connectionFlow3 3.5s ease-in-out infinite;
}

@keyframes connectionFlow1 {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.8;
  }
}

@keyframes connectionFlow2 {
  0%,
  100% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.9;
  }
}

@keyframes connectionFlow3 {
  0%,
  100% {
    opacity: 0.2;
  }
  50% {
    opacity: 0.7;
  }
}

/* ===== AWESOME GEOMETRIC ELEMENTS ===== */
.geometric-awesome {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.diamond-shape {
  position: absolute;
  background: linear-gradient(
    45deg,
    rgba(74, 222, 128, 0.1) 0%,
    rgba(34, 197, 94, 0.15) 50%,
    rgba(74, 222, 128, 0.08) 100%
  );
  border: 2px solid rgba(74, 222, 128, 0.3);
  backdrop-filter: blur(10px);
  transform: rotate(45deg);
  box-shadow: 0 0 25px rgba(74, 222, 128, 0.2),
    inset 0 0 15px rgba(255, 255, 255, 0.1);
}

.diamond-1 {
  width: 60px;
  height: 60px;
  top: 35%;
  left: 5%;
  animation: diamondSpin1 25s linear infinite;
}

.diamond-2 {
  width: 80px;
  height: 80px;
  bottom: 40%;
  right: 8%;
  animation: diamondSpin2 30s linear infinite reverse;
}

@keyframes diamondSpin1 {
  from {
    transform: rotate(45deg);
  }
  to {
    transform: rotate(405deg);
  }
}

@keyframes diamondSpin2 {
  from {
    transform: rotate(45deg);
  }
  to {
    transform: rotate(405deg);
  }
}

.rhombus-grid {
  position: absolute;
  top: 15%;
  left: 50%;
  width: 150px;
  height: 150px;
  background-image: linear-gradient(
      45deg,
      rgba(74, 222, 128, 0.1) 25%,
      transparent 25%
    ),
    linear-gradient(-45deg, rgba(74, 222, 128, 0.1) 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, rgba(34, 197, 94, 0.1) 75%),
    linear-gradient(-45deg, transparent 75%, rgba(34, 197, 94, 0.1) 75%);
  background-size: 20px 20px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
  opacity: 0.6;
  animation: rhombusShift 15s ease-in-out infinite;
}

@keyframes rhombusShift {
  0%,
  100% {
    transform: translate(-50%, 0) scale(1) rotate(0deg);
  }
  50% {
    transform: translate(-50%, -20px) scale(1.1) rotate(5deg);
  }
}

.hologram-ring {
  position: absolute;
  border: 2px solid rgba(74, 222, 128, 0.4);
  border-radius: 50%;
  background: radial-gradient(
    circle,
    transparent 60%,
    rgba(74, 222, 128, 0.1) 70%,
    transparent 80%
  );
  box-shadow: 0 0 30px rgba(74, 222, 128, 0.3),
    inset 0 0 30px rgba(74, 222, 128, 0.1);
}

.ring-1 {
  width: 120px;
  height: 120px;
  top: 55%;
  left: 70%;
  animation: ringPulse1 8s ease-in-out infinite;
}

.ring-2 {
  width: 80px;
  height: 80px;
  bottom: 30%;
  left: 20%;
  animation: ringPulse2 6s ease-in-out infinite;
}

@keyframes ringPulse1 {
  0%,
  100% {
    transform: scale(1) rotate(0deg);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.2) rotate(180deg);
    opacity: 0.8;
  }
}

@keyframes ringPulse2 {
  0%,
  100% {
    transform: scale(1) rotate(0deg);
    opacity: 0.6;
  }
  50% {
    transform: scale(1.3) rotate(-180deg);
    opacity: 0.9;
  }
}

.energy-wave {
  position: absolute;
  height: 2px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(74, 222, 128, 0.6) 50%,
    transparent 100%
  );
  box-shadow: 0 0 15px rgba(74, 222, 128, 0.4);
  border-radius: 1px;
}

.wave-1 {
  top: 40%;
  left: 10%;
  width: 200px;
  transform: rotate(20deg);
  animation: waveFlow1 12s ease-in-out infinite;
}

.wave-2 {
  bottom: 45%;
  right: 15%;
  width: 150px;
  transform: rotate(-30deg);
  animation: waveFlow2 10s ease-in-out infinite;
}

@keyframes waveFlow1 {
  0%,
  100% {
    opacity: 0.3;
    transform: rotate(20deg) scaleX(1);
  }
  50% {
    opacity: 0.8;
    transform: rotate(25deg) scaleX(1.2);
  }
}

@keyframes waveFlow2 {
  0%,
  100% {
    opacity: 0.4;
    transform: rotate(-30deg) scaleX(1);
  }
  50% {
    opacity: 0.9;
    transform: rotate(-25deg) scaleX(1.3);
  }
}

/* ===== AFRICA RISING: UNITY & TRANSFORMATION BACKGROUND ===== */
.africa-transformation-system {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
  overflow: hidden;
}

/* ===== FLOATING AFRICA EMBLEMS ===== */
.africa-emblems {
  position: absolute;
  top: 200px;
  left: 40px;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.africa-emblem {
  position: absolute;
  opacity: 0.15;
  animation: emblemFloat 25s ease-in-out infinite;
}

.emblem-1 {
  top: 10%;
  right: 10%;
  animation-delay: 0s;
}

.emblem-2 {
  bottom: 15%;
  left: 5%;
  animation-delay: 12s;
}

.emblem-image {
  width: 120px;
  height: auto;
  filter: contrast(1.2) brightness(1.1);
}

@keyframes emblemFloat {
  0%,
  100% {
    transform: translate(0, 0) rotate(0deg) scale(1);
    opacity: 0.15;
  }
  25% {
    transform: translate(20px, -15px) rotate(2deg) scale(1.05);
    opacity: 0.25;
  }
  50% {
    transform: translate(-15px, -25px) rotate(-1deg) scale(0.95);
    opacity: 0.2;
  }
  75% {
    transform: translate(25px, -10px) rotate(3deg) scale(1.02);
    opacity: 0.3;
  }
}

/* ===== DYNAMIC 54 NATIONS UNITY CONSTELLATION ===== */
.unity-constellation {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.nation-cluster {
  position: absolute;
  animation: clusterDrift 20s ease-in-out infinite;
}

.cluster-1 {
  top: 15%;
  left: 15%;
  animation-delay: 0s;
}

.cluster-2 {
  top: 35%;
  right: 20%;
  animation-delay: 5s;
}

.cluster-3 {
  bottom: 25%;
  left: 25%;
  animation-delay: 10s;
}

.cluster-4 {
  bottom: 40%;
  right: 15%;
  animation-delay: 15s;
}

@keyframes clusterDrift {
  0%,
  100% {
    transform: translate(0, 0);
  }
  25% {
    transform: translate(30px, -20px);
  }
  50% {
    transform: translate(-20px, -30px);
  }
  75% {
    transform: translate(25px, -15px);
  }
}

.nation-star {
  position: absolute;
  width: 5px;
  height: 5px;
  background: radial-gradient(
    circle,
    rgba(74, 222, 128, 1) 0%,
    rgba(34, 197, 94, 0.8) 100%
  );
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(74, 222, 128, 0.7),
    inset 0 0 3px rgba(255, 255, 255, 0.5);
  animation: starTwinkle 4s ease-in-out infinite;
}

/* Individual star positioning within clusters */
.star-1 {
  top: 0;
  left: 0;
  animation-delay: 0s;
}
.star-2 {
  top: -5px;
  left: 15px;
  animation-delay: 0.2s;
}
.star-3 {
  top: 10px;
  left: 25px;
  animation-delay: 0.4s;
}
.star-4 {
  top: 20px;
  left: 10px;
  animation-delay: 0.6s;
}
.star-5 {
  top: 15px;
  left: -5px;
  animation-delay: 0.8s;
}
.star-6 {
  top: 0;
  left: 0;
  animation-delay: 0s;
}
.star-7 {
  top: -8px;
  left: 18px;
  animation-delay: 0.3s;
}
.star-8 {
  top: 12px;
  left: 30px;
  animation-delay: 0.6s;
}
.star-9 {
  top: 25px;
  left: 8px;
  animation-delay: 0.9s;
}
.star-10 {
  top: 0;
  left: 0;
  animation-delay: 0s;
}
.star-11 {
  top: -10px;
  left: 20px;
  animation-delay: 0.4s;
}
.star-12 {
  top: 15px;
  left: 35px;
  animation-delay: 0.8s;
}
.star-13 {
  top: 30px;
  left: 15px;
  animation-delay: 1.2s;
}
.star-14 {
  top: 25px;
  left: -8px;
  animation-delay: 1.6s;
}
.star-15 {
  top: 0;
  left: 0;
  animation-delay: 0s;
}
.star-16 {
  top: -5px;
  left: 22px;
  animation-delay: 0.5s;
}
.star-17 {
  top: 18px;
  left: 12px;
  animation-delay: 1s;
}

@keyframes starTwinkle {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.3);
    opacity: 1;
  }
}

.connecting-bonds {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.bond {
  position: absolute;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(74, 222, 128, 0.3) 50%,
    transparent 100%
  );
  animation: bondFlow 5s ease-in-out infinite;
}

.bond-1 {
  top: 5px;
  left: 15px;
  width: 20px;
  transform: rotate(25deg);
}
.bond-2 {
  top: 15px;
  left: 8px;
  width: 25px;
  transform: rotate(-15deg);
}
.bond-3 {
  top: 20px;
  left: 20px;
  width: 18px;
  transform: rotate(45deg);
}
.bond-4 {
  top: 8px;
  left: 18px;
  width: 22px;
  transform: rotate(-30deg);
}
.bond-5 {
  top: 18px;
  left: 5px;
  width: 28px;
  transform: rotate(10deg);
}
.bond-6 {
  top: 12px;
  left: 25px;
  width: 20px;
  transform: rotate(35deg);
}
.bond-7 {
  top: 25px;
  left: 15px;
  width: 24px;
  transform: rotate(-20deg);
}
.bond-8 {
  top: 10px;
  left: 12px;
  width: 16px;
  transform: rotate(55deg);
}

@keyframes bondFlow {
  0%,
  100% {
    opacity: 0.2;
  }
  50% {
    opacity: 0.6;
  }
}

/* ===== DYNAMIC TRANSFORMATION SYMBOLS ===== */
.transformation-symbols {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* Growth Trees */
.growth-symbol {
  position: absolute;
  animation: symbolDrift 18s ease-in-out infinite;
}

.symbol-tree-1 {
  top: 25%;
  left: 8%;
  animation-delay: 0s;
}

.symbol-tree-2 {
  bottom: 20%;
  right: 12%;
  animation-delay: 9s;
}

@keyframes symbolDrift {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }
  25% {
    transform: translate(15px, -10px) scale(1.05);
  }
  50% {
    transform: translate(-10px, -18px) scale(0.95);
  }
  75% {
    transform: translate(20px, -8px) scale(1.02);
  }
}

.tree-trunk {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 3px;
  height: 25px;
  background: linear-gradient(
    to top,
    rgba(74, 222, 128, 0.7) 0%,
    rgba(34, 197, 94, 0.5) 100%
  );
  border-radius: 2px;
  animation: trunkGrow 6s ease-in-out infinite;
}

@keyframes trunkGrow {
  0%,
  100% {
    transform: translateX(-50%) scaleY(1);
  }
  50% {
    transform: translateX(-50%) scaleY(1.1);
  }
}

.tree-leaves {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}

.leaf {
  position: absolute;
  width: 4px;
  height: 4px;
  background: radial-gradient(
    circle,
    rgba(74, 222, 128, 0.9) 0%,
    rgba(34, 197, 94, 0.7) 100%
  );
  border-radius: 50% 0;
  animation: leafDance 8s ease-in-out infinite;
}

.leaf-1 {
  top: -8px;
  left: -12px;
  animation-delay: 0s;
}
.leaf-2 {
  top: -12px;
  left: 8px;
  animation-delay: 1s;
}
.leaf-3 {
  top: -6px;
  right: -10px;
  animation-delay: 2s;
}

@keyframes leafDance {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
    opacity: 0.7;
  }
  33% {
    transform: translateY(-5px) rotate(8deg);
    opacity: 1;
  }
  66% {
    transform: translateY(-3px) rotate(-5deg);
    opacity: 0.8;
  }
}

/* Innovation Lightbulbs */
.innovation-symbol {
  position: absolute;
  animation: innovationFloat 15s ease-in-out infinite;
}

.bulb-1 {
  top: 45%;
  left: 75%;
  animation-delay: 0s;
}

.bulb-2 {
  top: 65%;
  left: 15%;
  animation-delay: 7s;
}

@keyframes innovationFloat {
  0%,
  100% {
    transform: translate(0, 0) rotate(0deg);
  }
  25% {
    transform: translate(-12px, 18px) rotate(-2deg);
  }
  50% {
    transform: translate(15px, -20px) rotate(3deg);
  }
  75% {
    transform: translate(-8px, 12px) rotate(-1deg);
  }
}

.bulb-glow {
  width: 12px;
  height: 15px;
  background: radial-gradient(
    ellipse,
    rgba(74, 222, 128, 0.4) 0%,
    rgba(34, 197, 94, 0.3) 50%,
    transparent 70%
  );
  border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
  animation: bulbGlow 3s ease-in-out infinite;
}

@keyframes bulbGlow {
  0%,
  100% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.15);
  }
}

.innovation-sparks {
  position: absolute;
  top: -5px;
  left: -5px;
  width: 22px;
  height: 25px;
}

.spark {
  position: absolute;
  width: 2px;
  height: 2px;
  background: rgba(74, 222, 128, 0.8);
  border-radius: 50%;
  animation: sparkle 4s ease-in-out infinite;
}

.spark-1 {
  top: 2px;
  left: 8px;
  animation-delay: 0s;
}
.spark-2 {
  top: 8px;
  right: 5px;
  animation-delay: 1s;
}
.spark-3 {
  top: 5px;
  left: 3px;
  animation-delay: 2s;
}

@keyframes sparkle {
  0%,
  100% {
    opacity: 0;
    transform: scale(0.5);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
}

/* Leadership Crowns */
.leadership-symbol {
  position: absolute;
  animation: leadershipRise 20s ease-in-out infinite;
}

.crown-1 {
  top: 20%;
  right: 25%;
  animation-delay: 0s;
}

@keyframes leadershipRise {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(-10px, -25px) scale(1.08);
  }
}

.crown-peaks {
  position: relative;
}

.peak {
  position: absolute;
  width: 3px;
  background: linear-gradient(
    to top,
    rgba(74, 222, 128, 0.6) 0%,
    rgba(34, 197, 94, 0.8) 100%
  );
  border-radius: 1px;
}

.peak-1 {
  height: 12px;
  left: 0;
}
.peak-2 {
  height: 16px;
  left: 6px;
}
.peak-3 {
  height: 10px;
  left: 12px;
}

.crown-glow {
  position: absolute;
  top: -5px;
  left: -3px;
  width: 21px;
  height: 25px;
  background: radial-gradient(
    ellipse,
    rgba(74, 222, 128, 0.2) 0%,
    transparent 60%
  );
  animation: crownGlow 5s ease-in-out infinite;
}

@keyframes crownGlow {
  0%,
  100% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.8;
  }
}

/* Collaboration Circles */
.collaboration-symbol {
  position: absolute;
  animation: collaborationOrbit 25s ease-in-out infinite;
}

.collab-1 {
  top: 35%;
  left: 90%;
  animation-delay: 0s;
}

.collab-2 {
  bottom: 30%;
  left: 5%;
  animation-delay: 12s;
}

@keyframes collaborationOrbit {
  0%,
  100% {
    transform: translate(0, 0) rotate(0deg);
  }
  25% {
    transform: translate(-20px, 15px) rotate(90deg);
  }
  50% {
    transform: translate(-15px, -25px) rotate(180deg);
  }
  75% {
    transform: translate(18px, -20px) rotate(270deg);
  }
}

.collaboration-circle {
  position: relative;
  width: 30px;
  height: 30px;
}

.circle-ring {
  position: absolute;
  border: 1px solid rgba(74, 222, 128, 0.6);
  border-radius: 50%;
  animation: ringPulse 4s ease-in-out infinite;
}

.ring-outer {
  width: 30px;
  height: 30px;
  top: 0;
  left: 0;
  animation-delay: 0s;
}

.ring-middle {
  width: 20px;
  height: 20px;
  top: 5px;
  left: 5px;
  animation-delay: 1s;
}

.ring-inner {
  width: 10px;
  height: 10px;
  top: 10px;
  left: 10px;
  animation-delay: 2s;
}

@keyframes ringPulse {
  0%,
  100% {
    opacity: 0.3;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.15);
  }
}

.collaboration-nodes {
  position: absolute;
  top: 0;
  left: 0;
  width: 30px;
  height: 30px;
}

.collab-node {
  position: absolute;
  width: 3px;
  height: 3px;
  background: radial-gradient(
    circle,
    rgba(74, 222, 128, 0.9) 0%,
    rgba(34, 197, 94, 0.7) 100%
  );
  border-radius: 50%;
  animation: nodeConnect 6s ease-in-out infinite;
}

.node-1 {
  top: 2px;
  left: 13px;
  animation-delay: 0s;
}
.node-2 {
  top: 13px;
  right: 2px;
  animation-delay: 1s;
}
.node-3 {
  bottom: 2px;
  left: 13px;
  animation-delay: 2s;
}
.node-4 {
  top: 13px;
  left: 2px;
  animation-delay: 3s;
}

@keyframes nodeConnect {
  0%,
  100% {
    opacity: 0.5;
    transform: scale(1);
  }
  25% {
    opacity: 1;
    transform: scale(1.3);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.1);
  }
  75% {
    opacity: 0.9;
    transform: scale(1.2);
  }
}

/* ===== CONTINENTAL ENERGY FLOWS ===== */
.continental-energy {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.energy-flow {
  position: absolute;
  animation: energyFlow 20s ease-in-out infinite;
}

.flow-1 {
  top: 20%;
  left: 20%;
  animation-delay: 0s;
}

.flow-2 {
  top: 60%;
  right: 15%;
  animation-delay: 7s;
}

.flow-3 {
  bottom: 25%;
  left: 45%;
  animation-delay: 14s;
}

@keyframes energyFlow {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.4;
  }
  25% {
    transform: translate(25px, -15px) scale(1.1);
    opacity: 0.8;
  }
  50% {
    transform: translate(-20px, -30px) scale(0.9);
    opacity: 0.6;
  }
  75% {
    transform: translate(30px, -10px) scale(1.05);
    opacity: 0.7;
  }
}

.energy-stream {
  width: 40px;
  height: 3px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(74, 222, 128, 0.7) 25%,
    rgba(34, 197, 94, 0.9) 50%,
    rgba(74, 222, 128, 0.7) 75%,
    transparent 100%
  );
  border-radius: 2px;
  animation: streamPulse 4s ease-in-out infinite;
}

@keyframes streamPulse {
  0%,
  100% {
    opacity: 0.5;
    transform: scaleX(1);
  }
  50% {
    opacity: 1;
    transform: scaleX(1.3);
  }
}

.energy-particles {
  position: absolute;
  top: -10px;
  left: -10px;
  width: 60px;
  height: 23px;
}

.energy-particle {
  position: absolute;
  width: 2px;
  height: 2px;
  background: radial-gradient(
    circle,
    rgba(74, 222, 128, 1) 0%,
    rgba(34, 197, 94, 0.8) 100%
  );
  border-radius: 50%;
  animation: particleTravel 5s ease-in-out infinite;
}

.particle-e1 {
  top: 8px;
  left: 5px;
  animation-delay: 0s;
}
.particle-e2 {
  top: 12px;
  left: 25px;
  animation-delay: 1s;
}
.particle-e3 {
  top: 10px;
  left: 45px;
  animation-delay: 2s;
}

@keyframes particleTravel {
  0% {
    opacity: 0;
    transform: translateX(0);
  }
  25% {
    opacity: 1;
  }
  75% {
    opacity: 0.7;
  }
  100% {
    opacity: 0;
    transform: translateX(40px);
  }
}

/* ===== VISION BEACONS WITH LABELS ===== */
.vision-beacons {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.vision-beacon {
  position: absolute;
  animation: visionFloat 22s ease-in-out infinite;
}

.beacon-unity {
  top: 15%;
  left: 85%;
  animation-delay: 0s;
}

.beacon-transformation {
  bottom: 40%;
  left: 10%;
  animation-delay: 11s;
}

@keyframes visionFloat {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(-15px, -20px) scale(1.06);
  }
}

.beacon-core {
  position: relative;
  width: 6px;
  height: 25px;
  background: linear-gradient(
    to top,
    rgba(74, 222, 128, 0.9) 0%,
    rgba(34, 197, 94, 0.7) 100%
  );
  border-radius: 3px;
  animation: beaconCore 8s ease-in-out infinite;
}

@keyframes beaconCore {
  0%,
  100% {
    opacity: 0.6;
    transform: scaleY(1);
  }
  50% {
    opacity: 1;
    transform: scaleY(1.2);
  }
}

.beacon-aura {
  position: absolute;
  top: -8px;
  left: -8px;
  width: 22px;
  height: 41px;
  background: radial-gradient(
    ellipse,
    rgba(74, 222, 128, 0.3) 0%,
    rgba(34, 197, 94, 0.2) 40%,
    transparent 70%
  );
  border-radius: 50%;
  animation: beaconAura 6s ease-in-out infinite;
}

@keyframes beaconAura {
  0%,
  100% {
    opacity: 0.4;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.3);
  }
}

.vision-label {
  position: absolute;
  top: -35px;
  left: 50%;
  transform: translateX(-50%);
  padding: 3px 8px;
  background: rgba(26, 71, 42, 0.8);
  color: rgba(74, 222, 128, 0.9);
  font-size: 10px;
  font-weight: 500;
  border-radius: 8px;
  white-space: nowrap;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(74, 222, 128, 0.3);
  animation: labelGlow 7s ease-in-out infinite;
}

@keyframes labelGlow {
  0%,
  100% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
}

/* ===== HUMAN POTENTIAL RISING ELEMENTS ===== */
.human-potential-system {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.rising-figure {
  position: absolute;
}

.figure-1 {
  top: 30%;
  left: 60%;
}
.figure-2 {
  top: 70%;
  left: 40%;
}

.figure-body {
  position: absolute;
  width: 8px;
  height: 20px;
  background: linear-gradient(
    to top,
    rgba(74, 222, 128, 0.6) 0%,
    rgba(34, 197, 94, 0.8) 100%
  );
  border-radius: 4px 4px 2px 2px;
  animation: figureRise 10s ease-in-out infinite;
}

.potential-aura {
  position: absolute;
  top: -5px;
  left: -5px;
  width: 18px;
  height: 30px;
  background: radial-gradient(
    ellipse,
    rgba(74, 222, 128, 0.2) 0%,
    rgba(34, 197, 94, 0.1) 50%,
    transparent 70%
  );
  border-radius: 50%;
  animation: auraGlow 8s ease-in-out infinite;
}

@keyframes figureRise {
  0%,
  100% {
    transform: translateY(0) scale(1);
  }
  50% {
    transform: translateY(-8px) scale(1.1);
  }
}

@keyframes auraGlow {
  0%,
  100% {
    opacity: 0.4;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.2);
  }
}

.skills-emanation {
  position: absolute;
  top: -10px;
  left: -10px;
  width: 28px;
  height: 40px;
}

.skill-particle {
  position: absolute;
  width: 2px;
  height: 2px;
  background: radial-gradient(
    circle,
    rgba(74, 222, 128, 1) 0%,
    rgba(34, 197, 94, 0.8) 100%
  );
  border-radius: 50%;
  animation: skillEmanate 6s ease-in-out infinite;
}

.skill-1 {
  top: 5px;
  left: 10px;
  animation-delay: 0s;
}
.skill-2 {
  top: 15px;
  right: 8px;
  animation-delay: 1s;
}
.skill-3 {
  top: 25px;
  left: 12px;
  animation-delay: 2s;
}

@keyframes skillEmanate {
  0% {
    opacity: 0;
    transform: scale(0.5) translateY(0);
  }
  50% {
    opacity: 1;
    transform: scale(1) translateY(-15px);
  }
  100% {
    opacity: 0;
    transform: scale(0.5) translateY(-30px);
  }
}

/* ===== CONTINENTAL BRIDGE NETWORKS ===== */
.continental-bridges {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.unity-bridge {
  fill: none;
  stroke-width: 0.2;
  opacity: 0.5;
  filter: drop-shadow(0 0 4px rgba(74, 222, 128, 0.3));
  stroke-linecap: round;
}

.bridge-primary {
  stroke: rgba(74, 222, 128, 0.7);
  stroke-dasharray: 2 1;
  animation: bridgeFlow1 12s linear infinite;
}

.bridge-secondary {
  stroke: rgba(34, 197, 94, 0.6);
  stroke-dasharray: 1.5 0.8;
  animation: bridgeFlow2 14s linear infinite;
}

.bridge-tertiary {
  stroke: rgba(22, 163, 74, 0.5);
  stroke-dasharray: 1 0.5;
  animation: bridgeFlow3 16s linear infinite;
}

.bridge-quaternary {
  stroke: rgba(74, 222, 128, 0.8);
  stroke-dasharray: 2.5 1.2;
  animation: bridgeFlow4 10s linear infinite;
}

@keyframes bridgeFlow1 {
  0% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: 6;
  }
}

@keyframes bridgeFlow2 {
  0% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: 4.6;
  }
}

@keyframes bridgeFlow3 {
  0% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: 3;
  }
}

@keyframes bridgeFlow4 {
  0% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: 7.4;
  }
}

.transformation-wave {
  fill: none;
  stroke-width: 0.15;
  opacity: 0.4;
  stroke-linecap: round;
}

.wave-growth {
  stroke: rgba(74, 222, 128, 0.6);
  stroke-dasharray: 3 2;
  animation: transformationFlow1 18s linear infinite;
}

.wave-innovation {
  stroke: rgba(34, 197, 94, 0.5);
  stroke-dasharray: 2 1;
  animation: transformationFlow2 20s linear infinite;
}

.wave-future {
  stroke: rgba(22, 163, 74, 0.4);
  stroke-dasharray: 1.5 1;
  animation: transformationFlow3 22s linear infinite;
}

@keyframes transformationFlow1 {
  0% {
    stroke-dashoffset: 0;
    opacity: 0.3;
  }
  50% {
    opacity: 0.7;
  }
  100% {
    stroke-dashoffset: 10;
    opacity: 0.3;
  }
}

@keyframes transformationFlow2 {
  0% {
    stroke-dashoffset: 0;
    opacity: 0.2;
  }
  50% {
    opacity: 0.6;
  }
  100% {
    stroke-dashoffset: 6;
    opacity: 0.2;
  }
}

@keyframes transformationFlow3 {
  0% {
    stroke-dashoffset: 0;
    opacity: 0.2;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    stroke-dashoffset: 5;
    opacity: 0.2;
  }
}

/* ===== FUTURE VISION PORTALS ===== */
.future-vision-portals {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.vision-portal {
  position: absolute;
}

.portal-1 {
  top: 20%;
  right: 20%;
}
.portal-2 {
  bottom: 25%;
  left: 25%;
}

.portal-ring {
  position: absolute;
  border-radius: 50%;
  border: 1px solid rgba(74, 222, 128, 0.3);
  animation: portalPulse 8s ease-in-out infinite;
}

.ring-outer {
  width: 40px;
  height: 40px;
  top: -20px;
  left: -20px;
  animation-delay: 0s;
}

.ring-middle {
  width: 25px;
  height: 25px;
  top: -12px;
  left: -12px;
  animation-delay: 1s;
}

.ring-inner {
  width: 15px;
  height: 15px;
  top: -7px;
  left: -7px;
  animation-delay: 2s;
}

.portal-core {
  position: absolute;
  width: 6px;
  height: 6px;
  top: -3px;
  left: -3px;
  background: radial-gradient(
    circle,
    rgba(74, 222, 128, 0.9) 0%,
    rgba(34, 197, 94, 0.6) 100%
  );
  border-radius: 50%;
  box-shadow: 0 0 12px rgba(74, 222, 128, 0.8);
  animation: coreGlow 6s ease-in-out infinite;
}

@keyframes portalPulse {
  0%,
  100% {
    opacity: 0.3;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.1);
  }
}

@keyframes coreGlow {
  0%,
  100% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.3);
  }
}

/* ===== WORKFORCE INNOVATION SPIRALS ===== */
.innovation-spirals {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.innovation-spiral {
  position: absolute;
  width: 60px;
  height: 60px;
  border: 2px solid rgba(74, 222, 128, 0.3);
  border-radius: 50%;
  border-top: 2px solid rgba(74, 222, 128, 0.8);
  animation: spiralInnovation 15s linear infinite;
}

.spiral-1 {
  top: 45%;
  left: 80%;
  animation-delay: 0s;
}
.spiral-2 {
  top: 25%;
  left: 30%;
  animation-delay: 5s;
}
.spiral-3 {
  bottom: 35%;
  right: 30%;
  animation-delay: 10s;
}

@keyframes spiralInnovation {
  0% {
    transform: rotate(0deg) scale(1);
    opacity: 0.3;
  }
  25% {
    opacity: 0.7;
  }
  50% {
    transform: rotate(180deg) scale(1.1);
    opacity: 0.9;
  }
  75% {
    opacity: 0.7;
  }
  100% {
    transform: rotate(360deg) scale(1);
    opacity: 0.3;
  }
}

/* ===== LEADERSHIP EXCELLENCE BEACONS ===== */
.leadership-beacons {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.beacon {
  position: absolute;
}

.beacon-1 {
  top: 35%;
  left: 10%;
}
.beacon-2 {
  bottom: 40%;
  right: 10%;
}

.beacon-light {
  position: absolute;
  width: 8px;
  height: 30px;
  background: linear-gradient(
    to top,
    rgba(74, 222, 128, 0.8) 0%,
    rgba(34, 197, 94, 0.6) 50%,
    rgba(74, 222, 128, 0.4) 100%
  );
  border-radius: 4px;
  animation: beaconShine 10s ease-in-out infinite;
}

.beacon-pulse {
  position: absolute;
  top: -5px;
  left: -5px;
  width: 18px;
  height: 40px;
  border: 1px solid rgba(74, 222, 128, 0.4);
  border-radius: 50%;
  animation: beaconPulse 8s ease-in-out infinite;
}

.pulse-1 {
  animation-delay: 0s;
}
.pulse-2 {
  animation-delay: 2s;
}

@keyframes beaconShine {
  0%,
  100% {
    opacity: 0.5;
    transform: scaleY(1);
  }
  50% {
    opacity: 1;
    transform: scaleY(1.2);
  }
}

@keyframes beaconPulse {
  0%,
  100% {
    opacity: 0.2;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.3);
  }
}

/* Enhanced Geometric Overlay with Floating Shapes */
.geometric-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 2;
}

.floating-shape {
  position: absolute;
  background: linear-gradient(
    135deg,
    rgba(74, 222, 128, 0.12) 0%,
    rgba(34, 197, 94, 0.18) 100%
  );
  border-radius: 50%;
  backdrop-filter: blur(15px);
  border: 2px solid rgba(74, 222, 128, 0.25);
  box-shadow: 0 0 20px rgba(74, 222, 128, 0.15),
    inset 0 0 20px rgba(74, 222, 128, 0.1);
  transition: all 0.3s ease;
}

.shape-1 {
  width: 120px;
  height: 120px;
  top: 10%;
  left: 85%;
  animation: floatUpDown 8s ease-in-out infinite;
}

.shape-2 {
  width: 80px;
  height: 80px;
  top: 30%;
  left: 5%;
  animation: floatUpDown 12s ease-in-out infinite reverse;
  animation-delay: -3s;
}

.shape-3 {
  width: 100px;
  height: 100px;
  top: 65%;
  left: 90%;
  animation: floatUpDown 10s ease-in-out infinite;
  animation-delay: -6s;
}

.shape-4 {
  width: 60px;
  height: 60px;
  top: 80%;
  left: 10%;
  animation: floatUpDown 15s ease-in-out infinite reverse;
  animation-delay: -9s;
}

/* Animations */
@keyframes slowFloat {
  0%,
  100% {
    transform: translateY(0px) scale(1);
  }
  50% {
    transform: translateY(-20px) scale(1.02);
  }
}

@keyframes floatUpDown {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-30px);
  }
}

/* Enhanced Section Backgrounds with Unified Theme */
.unified-background-container .about-section,
.unified-background-container .objectives-section,
.unified-background-container .themes-section,
.unified-background-container .pricing-section,
.unified-background-container .contact-section {
  background: transparent !important;
  position: relative;
  z-index: 3;
}

/* Ensure components outside unified container have proper z-index */
.home > div:not(.unified-background-container) {
  position: relative;
  z-index: 100;
}

/* Add subtle backdrop filter to content sections for better readability */
.unified-background-container .about-section .container-wide,
.unified-background-container .objectives-section .container-wide,
.unified-background-container .themes-section .container-wide,
.unified-background-container .pricing-section .container-wide,
.unified-background-container .contact-section .container-wide {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 60px 40px;
  margin: 40px 0;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: none !important;
  width: 100%;
}


/* Responsive Design for Background System */
@media (max-width: 1200px) {
  .background-layer-1 {
    clip-path: polygon(0 0, 80% 0, 60% 40%, 0 35%);
    animation-duration: 40s; /* Slower animations for better performance */
  }

  .background-layer-2 {
    clip-path: polygon(20% 0, 100% 0, 100% 60%, 50% 55%);
    animation-duration: 45s;
  }

  .floating-shape {
    opacity: 0.8;
    animation-duration: 20s; /* Reduced from complex values */
  }

  /* Reduce complexity on medium screens */
  .particle-field {
    opacity: 0.7;
  }

  .light-stream {
    opacity: 0.6;
  }
}

@media (max-width: 768px) {
  .unified-background-container {
    background: linear-gradient(180deg, #f8fffe 0%, #f0f8f0 50%, #ffffff 100%);
  }

  .background-layer {
    opacity: 0.3 !important;
  }

  /* Performance optimizations for mobile */
  .futuristic-background-layer {
    opacity: 0.5;
    transform: translateZ(0);
    will-change: transform;
  }

  /* Reduce animation complexity on mobile */
  .africa-transformation-system,
  .geometric-awesome,
  .crystal-network,
  .glass-fragments {
    display: none;
  }

  .grid-pattern {
    opacity: 0.03;
    background-size: 30px 30px;
  }

  .light-stream {
    width: 1px;
    opacity: 0.6;
  }

  .particle {
    width: 3px;
    height: 3px;
    opacity: 0.6;
  }

  .neo-shape {
    opacity: 0.4;
    border-width: 1px;
  }

  .neo-hexagon {
    width: 50px;
    height: 50px;
  }

  .neo-triangle {
    width: 40px;
    height: 40px;
  }

  .neo-circle {
    width: 60px;
    height: 60px;
  }

  .gradient-orb {
    opacity: 0.5;
  }

  .orb-1 {
    width: 120px;
    height: 120px;
  }

  .orb-2 {
    width: 100px;
    height: 100px;
  }

  .orb-3 {
    width: 80px;
    height: 80px;
  }

  /* Mobile optimizations for new elements */
  .glass-fragments {
    opacity: 0.6;
  }

  .glass-shard {
    opacity: 0.5;
    border-width: 1px;
  }

  .shard-1 {
    width: 50px;
    height: 75px;
  }

  .shard-2 {
    width: 40px;
    height: 60px;
  }

  .shard-3 {
    width: 60px;
    height: 45px;
  }

  .shard-4 {
    width: 45px;
    height: 70px;
  }

  .shard-5 {
    width: 55px;
    height: 40px;
  }

  .shard-6 {
    width: 35px;
    height: 50px;
  }

  .crystal-network {
    opacity: 0.7;
  }

  .crystal-node {
    width: 8px;
    height: 8px;
  }

  .crystal-connection {
    opacity: 0.6;
  }

  .geometric-awesome {
    opacity: 0.5;
  }

  .diamond-shape {
    border-width: 1px;
  }

  .diamond-1 {
    width: 40px;
    height: 40px;
  }

  .diamond-2 {
    width: 50px;
    height: 50px;
  }

  .rhombus-grid {
    width: 100px;
    height: 100px;
    background-size: 15px 15px;
  }

  .hologram-ring {
    border-width: 1px;
  }

  .ring-1 {
    width: 80px;
    height: 80px;
  }

  .ring-2 {
    width: 60px;
    height: 60px;
  }

  /* Africa Rising System - Mobile Optimizations */
  .africa-emblems {
    opacity: 0.8;
  }

  .africa-emblem {
    transform: scale(0.7);
  }

  .emblem-image {
    opacity: 0.7;
    filter: blur(0.5px);
  }

  .unity-constellation {
    opacity: 0.6;
  }

  .nation-star {
    width: 3px;
    height: 3px;
  }

  .bond {
    opacity: 0.4;
  }

  /* Transformation Symbols - Mobile */
  .transformation-symbols {
    opacity: 0.7;
  }

  .tree-trunk {
    width: 2px;
    height: 18px;
  }

  .leaf {
    width: 3px;
    height: 3px;
  }

  .bulb-glow {
    width: 8px;
    height: 10px;
  }

  .spark {
    width: 1px;
    height: 1px;
  }

  .crown-peaks .peak {
    width: 2px;
  }

  .peak-1 {
    height: 8px;
  }
  .peak-2 {
    height: 12px;
  }
  .peak-3 {
    height: 6px;
  }

  /* Collaboration Circles - Mobile */
  .collaboration-circle {
    transform: scale(0.8);
  }

  .collab-node {
    width: 2px;
    height: 2px;
  }

  /* Continental Energy Flows - Mobile */
  .continental-energy {
    opacity: 0.6;
  }

  .energy-stream {
    width: 25px;
    height: 2px;
  }

  .energy-particle {
    width: 1.5px;
    height: 1.5px;
  }

  /* Vision Beacons - Mobile */
  .vision-beacons {
    opacity: 0.8;
  }

  .beacon-core {
    width: 4px;
    height: 18px;
  }

  .vision-label {
    font-size: 8px;
    padding: 2px 6px;
    top: -25px;
  }

  /* Human Potential System - Mobile */
  .human-potential-system {
    opacity: 0.6;
  }

  .figure-body {
    width: 6px;
    height: 15px;
  }

  .skill-particle {
    width: 1.5px;
    height: 1.5px;
  }

  /* Continental Bridges - Mobile */
  .continental-bridges {
    opacity: 0.5;
  }

  .unity-bridge {
    stroke-width: 0.15;
  }

  .transformation-wave {
    stroke-width: 0.1;
  }

  /* Workforce Innovation Spirals - Mobile */
  .innovation-spiral {
    opacity: 0.6;
    transform: scale(0.8);
  }

  /* Leadership Beacons - Mobile */
  .leadership-beacons {
    opacity: 0.7;
  }

  .beacon-light {
    width: 6px;
    height: 20px;
  }

  .energy-wave {
    height: 1px;
  }

  .wave-1 {
    width: 120px;
  }

  .wave-2 {
    width: 100px;
  }

  /* Mobile optimizations for Africa transformation system */
  .africa-transformation-system {
    opacity: 0.6;
  }

  .nation-star {
    width: 4px;
    height: 4px;
  }

  .bond {
    opacity: 0.4;
  }

  .tree-trunk {
    width: 2px;
    height: 25px;
  }

  .leaf {
    width: 3px;
    height: 3px;
  }

  .figure-body {
    width: 6px;
    height: 15px;
  }

  .skill-particle {
    width: 1px;
    height: 1px;
  }

  .unity-bridge {
    stroke-width: 0.1;
    opacity: 0.3;
  }

  .portal-ring {
    opacity: 0.4;
  }

  .ring-outer {
    width: 25px;
    height: 25px;
    top: -12px;
    left: -12px;
  }

  .ring-middle {
    width: 15px;
    height: 15px;
    top: -7px;
    left: -7px;
  }

  .innovation-spiral {
    width: 40px;
    height: 40px;
    border-width: 1px;
  }

  .beacon-light {
    width: 5px;
    height: 20px;
  }

  .background-layer-1 {
    clip-path: polygon(0 0, 100% 0, 80% 30%, 0 25%);
  }

  .background-layer-2 {
    clip-path: polygon(20% 70%, 100% 65%, 100% 100%, 0 100%);
  }

  .background-layer-3,
  .background-layer-4 {
    display: none;
  }

  .floating-shape {
    width: 60px !important;
    height: 60px !important;
  }

  .unified-background-container .about-section .container-wide,
  .unified-background-container .objectives-section .container-wide,
  .unified-background-container .themes-section .container-wide,
  .unified-background-container .pricing-section .container-wide,
  .unified-background-container .contact-section .container-wide {
    margin: 20px 10px;
    padding: 40px 20px;
    border-radius: 15px;
    width: calc(100% - 20px);
    max-width: none !important;
  }

}

/* About Section */
.about-section {
  padding: 100px 0;
  background: var(--color-white);
  position: relative;
}

/* Unified About Section Styles */
.unified-about {
  padding: 120px 0;
  position: relative;
  background: transparent;
}

.unified-about .container-wide {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(15px) !important;
  border: 1px solid rgba(74, 222, 128, 0.1);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.1);
}

/* Update text colors for unified theme */
.unified-about .futuristic-title {
  color: var(--color-primary-dark);
}

.unified-about .title-highlight {
  color: var(--color-primary-light);
  font-size: 2.5rem;
  font-weight: 400;
  letter-spacing: 8px;
  margin-bottom: 10px;
}

.unified-about .title-main {
  color: var(--color-primary-dark);
}

.unified-about .summit-name {
  color: var(--color-primary-dark);
}

.unified-about .summit-acronym {
  color: var(--color-primary-light);
}

.unified-about .description-text {
  color: var(--color-text-primary);
}

.unified-about .text-highlight {
  color: var(--color-primary);
  font-weight: 600;
}

.unified-about .theme-label {
  color: var(--color-primary-light);
}

.unified-about .theme-text {
  color: var(--color-primary-dark);
}

.unified-about .info-header {
  color: var(--color-primary-light);
}

.unified-about .info-label {
  color: var(--color-primary);
}

.unified-about .info-value {
  color: var(--color-text-primary);
}

.unified-about .event-info-card {
  background: rgba(248, 255, 254, 0.9);
  border: 1px solid rgba(74, 222, 128, 0.2);
  backdrop-filter: blur(10px);
}

.unified-about .info-icon {
  background: rgba(74, 222, 128, 0.15);
  color: var(--color-primary);
}

.unified-about .feature-stat {
  background: rgba(248, 255, 254, 0.9);
  border: 1px solid rgba(74, 222, 128, 0.2);
  backdrop-filter: blur(10px);
}

.unified-about .stat-number {
  color: var(--color-primary-light);
}

.unified-about .stat-label {
  color: var(--color-text-secondary);
}

.about-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--gradient-cta);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  font-size: 2.8rem;
  color: var(--color-primary-dark);
  text-align: center;
  margin-bottom: 20px;
  font-weight: 700;
}

.section-subtitle {
  font-size: 2rem;
  color: var(--color-primary);
  text-align: center;
  margin-bottom: 50px;
  font-weight: 600;
}

.about-content {
  width: 100%;
  margin: 0;
  text-align: center;
  background: transparent;
  padding: 40px 0;
}

.about-text {
  font-size: 1.2rem;
  line-height: 1.9;
  color: #333333 !important;
  margin-bottom: 25px;
  font-weight: 400;
  text-align: center;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 25px;
}

/* Futuristic About Section Styles */
.futuristic-about {
  padding: 100px 0;
  background: linear-gradient(135deg, #0a0f1c 0%, #1a2332 50%, #0f1419 100%);
  color: white;
  position: relative;
  overflow: hidden;
}

.futuristic-about::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
    ellipse at center,
    rgba(76, 222, 128, 0.1) 0%,
    transparent 70%
  );
  pointer-events: none;
}

/* Hero Content */
.about-hero-content {
  text-align: center;
  margin-bottom: 80px;
  position: relative;
}

.event-badge {
  display: inline-block;
  padding: 8px 24px;
  background: rgba(76, 222, 128, 0.2);
  border: 1px solid #4ade80;
  border-radius: 50px;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 2px;
  margin-bottom: 30px;
  color: #4ade80;
}

.futuristic-title {
  font-family: "Poppins", "Inter", sans-serif;
  font-size: 4.5rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.1;
  letter-spacing: -2px;
}

.title-highlight {
  color: #4ade80;
  display: block;
  font-size: 2.5rem;
  font-weight: 400;
  letter-spacing: 8px;
  margin-bottom: 10px;
}

.title-main {
  color: white;
  display: block;
}

.title-underline {
  width: 120px;
  height: 4px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    #4ade80 50%,
    transparent 100%
  );
  margin: 30px auto 0;
  border-radius: 2px;
}

/* Main Grid Layout */
.about-grid {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 80px;
  align-items: start;
  margin-bottom: 80px;
}

.summit-name {
  font-family: "Poppins", sans-serif;
  font-size: 2.5rem;
  font-weight: 300;
  color: white;
  margin-bottom: 10px;
  line-height: 1.2;
}

.summit-acronym {
  font-family: "Poppins", sans-serif;
  font-size: 4rem;
  font-weight: 800;
  color: #4ade80;
  margin-bottom: 40px;
  letter-spacing: 4px;
}

.description-text {
  font-size: 1.3rem;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 50px;
  font-weight: 300;
}

.text-highlight {
  color: #4ade80;
  font-weight: 500;
}

.theme-section {
  padding: 30px 0;
  border-top: 1px solid rgba(76, 222, 128, 0.3);
  border-bottom: 1px solid rgba(76, 222, 128, 0.3);
}

.theme-label {
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 2px;
  color: #4ade80;
  margin-bottom: 15px;
}

.theme-text {
  font-size: 1.8rem;
  font-weight: 400;
  color: white;
  font-style: italic;
  line-height: 1.4;
}

.event-info-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(76, 222, 128, 0.3);
  border-radius: 20px;
  padding: 40px 30px;
  backdrop-filter: blur(10px);
  position: relative;
}

.event-info-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(76, 222, 128, 0.1) 0%,
    transparent 100%
  );
  border-radius: 20px;
  pointer-events: none;
}

.info-header {
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 2px;
  color: #4ade80;
  margin-bottom: 30px;
  text-align: center;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 30px;
  position: relative;
}

.info-icon {
  width: 50px;
  height: 50px;
  background: rgba(76, 222, 128, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4ade80;
  flex-shrink: 0;
}

.info-icon svg {
  width: 24px;
  height: 24px;
}

.info-label {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 1px;
  color: #4ade80;
  margin-bottom: 8px;
}

.info-value {
  font-size: 1.1rem;
  font-weight: 400;
  color: white;
  line-height: 1.4;
}

/* Features Banner */
.features-banner {
  margin-top: 80px;
  position: relative;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
}

.feature-stat {
  text-align: center;
  padding: 40px 20px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(76, 222, 128, 0.2);
  border-radius: 16px;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.feature-stat:hover {
  transform: translateY(-10px);
  border-color: #4ade80;
  background: rgba(76, 222, 128, 0.1);
}

.stat-number {
  font-family: "Poppins", sans-serif;
  font-size: 3rem;
  font-weight: 700;
  color: #4ade80;
  margin-bottom: 10px;
  line-height: 1;
}

.stat-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.8);
  letter-spacing: 1px;
}

/* Responsive Design for Futuristic About */
@media (max-width: 1200px) {
  .about-grid {
    grid-template-columns: 1fr;
    gap: 60px;
  }

  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .futuristic-title {
    font-size: 3rem;
  }

  .title-highlight {
    font-size: 1.8rem;
    letter-spacing: 4px;
  }

  .summit-name {
    font-size: 2rem;
  }

  .summit-acronym {
    font-size: 3rem;
    letter-spacing: 2px;
  }

  .description-text {
    font-size: 1.1rem;
  }

  .features-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .event-info-card {
    padding: 30px 20px;
  }
}

/* Summit Features */
.summit-features {
  margin: 50px 0;
}

.feature-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-top: 30px;
}

.feature-item {
  text-align: center;
  padding: 30px 20px;
  background: var(--color-white);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-md);
}

.feature-icon {
  font-size: 2.5rem;
  margin-bottom: 15px;
}

.feature-item h4 {
  color: var(--color-primary);
  font-size: 1.2rem;
  margin-bottom: 10px;
  font-weight: 600;
}

.feature-item p {
  color: #666666 !important;
  font-size: 0.95rem;
  line-height: 1.6;
}

/* Expectations Section */
.expectations-section {
  margin: 50px 0;
  text-align: left;
}

.expectations-title {
  color: var(--color-primary-dark);
  font-size: 1.8rem;
  text-align: center;
  margin-bottom: 30px;
  font-weight: 600;
}

.expectations-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 25px;
}

.expectation-item {
  display: flex;
  align-items: flex-start;
  padding: 20px;
  background: var(--color-white);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  transition: box-shadow 0.3s ease;
}

.expectation-item:hover {
  box-shadow: var(--shadow-md);
}

.expectation-bullet {
  color: var(--color-success);
  font-weight: bold;
  font-size: 1.2rem;
  margin-right: 15px;
  flex-shrink: 0;
}

.expectation-text {
  color: #333333 !important;
  line-height: 1.6;
  font-size: 0.95rem;
}

/* Impact Section */
.impact-section {
  margin: 50px 0 0;
  padding: 40px;
  background: var(--gradient-primary);
  border-radius: var(--radius-lg);
  color: var(--color-white);
}

.impact-title {
  font-size: 1.8rem;
  text-align: center;
  margin-bottom: 25px;
  font-weight: 600;
  color: var(--color-white);
}

.impact-text {
  font-size: 1.1rem;
  line-height: 1.8;
  text-align: center;
  color: var(--color-white);
  opacity: 0.95;
}

/* THRAPA Events */
.thrapa-events {
  margin-top: 40px;
  padding-top: 30px;
  border-top: 1px solid rgba(34, 139, 34, 0.15);
  text-align: center;
}

.thrapa-events-label {
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--color-primary);
  font-weight: 600;
  margin-bottom: 14px;
}

.thrapa-events-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
}

.event-chip {
  display: inline-block;
  padding: 6px 16px;
  border-radius: 50px;
  font-size: 0.85rem;
  font-weight: 500;
  background: rgba(34, 139, 34, 0.1);
  border: 1px solid rgba(34, 139, 34, 0.3);
  color: var(--color-primary-dark);
}

.event-chip-upcoming {
  background: rgba(34, 139, 34, 0.2);
  border-color: var(--color-primary);
  color: var(--color-primary);
  font-weight: 600;
}

/* Partners Section */
.partners-section {
  padding: 80px 0;
}

.partners-section .section-title {
  text-align: center;
  font-size: 2.4rem;
  font-weight: 700;
  color: var(--color-primary-dark);
  margin-bottom: 12px;
}

.partners-section .section-subtitle {
  text-align: center;
  color: var(--color-text-secondary);
  font-size: 1.05rem;
  margin-bottom: 50px;
}

.partners-teaser {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;
}

.partners-count {
  font-size: 1.15rem;
  color: var(--color-text-secondary);
  font-style: italic;
  margin: 0;
}

.btn-partners {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: var(--color-primary);
  color: #fff;
  padding: 14px 36px;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 4px 16px rgba(34, 139, 34, 0.3);
}

.btn-partners:hover {
  background: var(--color-primary-dark);
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(34, 139, 34, 0.4);
  color: #fff;
}

.partner-name {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--color-primary-dark);
  line-height: 1.3;
}

.partner-region {
  font-size: 0.75rem;
  color: var(--color-text-secondary);
  margin-top: 4px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* Admin Contacts */
.admin-contacts {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.admin-contact-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.admin-name {
  font-weight: 600;
  color: var(--color-primary-dark);
  font-size: 0.95rem;
}

.admin-email,
.admin-phone {
  font-size: 0.875rem;
  color: var(--color-primary);
  text-decoration: none;
  transition: color 0.2s ease;
}

.admin-email:hover,
.admin-phone:hover {
  color: var(--color-primary-dark);
  text-decoration: underline;
}

/* Objectives Section */
.objectives-section {
  padding: 80px 0;
  background: var(--color-background-light);
}

.objectives-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
  margin-top: 50px;
  max-width: none;
}

@media (max-width: 1200px) {
  .objectives-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .objectives-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .objectives-grid {
    grid-template-columns: 1fr;
  }
}

.objective-card {
  background: var(--color-white);
  padding: 40px 30px;
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-md);
  text-align: center;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.objective-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-xl);
  border-color: var(--color-primary-light);
}

.objective-icon {
  margin-bottom: 20px;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: var(--gradient-cta);
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.creative-icon {
  width: 40px;
  height: 40px;
  stroke: white;
  stroke-width: 2;
}

.objective-card:hover .objective-icon {
  transform: scale(1.1);
  background: var(--gradient-hover);
}

.icon-placeholder {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: var(--gradient-primary);
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
}

.objective-title {
  font-size: 1.4rem;
  color: var(--color-primary-dark);
  margin-bottom: 15px;
  font-weight: bold;
}

.objective-text {
  font-size: 1rem;
  color: var(--color-text-primary);
  line-height: 1.6;
}

/* Statistics Section */
.stats-section {
  padding: 60px 0;
  background: var(--color-white);
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 40px;
  text-align: center;
}

.stat-item {
  background: var(--color-white);
  padding: 40px 20px;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  transition: transform 0.3s ease;
}

.stat-item:hover {
  transform: translateY(-5px);
}

.stat-number {
  display: block;
  font-size: 3rem;
  font-weight: bold;
  color: var(--color-primary);
  margin-bottom: 10px;
}

.stat-label {
  font-size: 1.2rem;
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Themes Section */
.themes-section {
  padding: 60px 0;
  background: var(--color-background-light);
}

.themes-description {
  text-align: center;
  font-size: 1.3rem;
  color: var(--color-text-primary);
  margin-bottom: 50px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  font-weight: 500;
  line-height: 1.6;
  padding: 0 20px;
}

.themes-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-top: 40px;
}

.theme-card {
  background: var(--color-white);
  padding: 25px 20px;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  transition: all 0.3s ease;
  border-left: 4px solid var(--color-primary);
}

.theme-card:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-lg);
}

.theme-card h3 {
  font-size: 1.2rem;
  color: var(--color-primary-dark);
  margin-bottom: 12px;
  font-weight: bold;
  line-height: 1.3;
}

.theme-card p {
  color: var(--color-text-primary);
  line-height: 1.5;
  margin-bottom: 15px;
  font-size: 0.95rem;
}

.theme-highlights {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.highlight {
  background: var(--color-primary-light);
  color: white;
  padding: 4px 10px;
  border-radius: var(--radius-sm);
  font-size: 0.8rem;
  font-weight: 500;
}

/* Responsive adjustments for themes */
@media (max-width: 1200px) {
  .themes-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
  }
}

@media (max-width: 768px) {
  .themes-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .theme-card {
    padding: 20px 15px;
  }
}

/* Event Agenda - Two Panel Layout */
.agenda-section {
  background: linear-gradient(
    135deg,
    rgba(26, 71, 42, 0.95) 0%,
    rgba(45, 95, 63, 0.95) 50%,
    rgba(34, 139, 34, 0.9) 100%
  );
  padding: 120px 0;
  position: relative;
  overflow: hidden;
}

.agenda-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
      ellipse at 20% 20%,
      rgba(76, 222, 128, 0.1) 0%,
      transparent 50%
    ),
    radial-gradient(
      ellipse at 80% 80%,
      rgba(34, 197, 94, 0.1) 0%,
      transparent 50%
    );
  pointer-events: none;
}

/* Two-Panel Grid Layout */
.agenda-layout {
  display: grid;
  grid-template-columns: 1fr 500px;
  gap: 60px;
  min-height: 800px;
  align-items: start;
}

/* Left Panel - Dynamic Content */
.agenda-content-panel {
  background: linear-gradient(
    135deg,
    rgba(26, 71, 42, 0.15) 0%,
    rgba(45, 95, 63, 0.12) 50%,
    rgba(34, 139, 34, 0.1) 100%
  );
  border-radius: 32px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  backdrop-filter: blur(20px);
  position: relative;
}

.agenda-content-panel::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #4ade80 0%, #22c55e 100%);
}

.agenda-scroll-container {
  height: 800px;
  overflow-y: auto;
  padding: 40px;
  scroll-behavior: smooth;
}

/* Completely Hide scrollbar */
.agenda-scroll-container::-webkit-scrollbar {
  display: none;
}

.agenda-scroll-container {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

/* Day Content Styles */
.day-content {
  position: relative;
}

.day-header-large {
  display: flex;
  align-items: center;
  gap: 25px;
  margin-bottom: 40px;
  padding-bottom: 25px;
  border-bottom: 2px solid rgba(76, 222, 128, 0.2);
}

.day-number-large {
  font-size: 4rem;
  font-weight: 800;
  color: #4ade80;
  font-family: "Poppins", sans-serif;
  line-height: 1;
  text-shadow: 0 4px 12px rgba(76, 222, 128, 0.3);
}

.day-info-large {
  flex: 1;
}

.day-title-large {
  font-size: 2rem;
  font-weight: 700;
  color: #1a472a;
  margin-bottom: 8px;
  line-height: 1.2;
}

.day-date-large {
  font-size: 1.1rem;
  color: #666;
  margin-bottom: 5px;
}

.day-theme {
  font-size: 1rem;
  color: #4ade80;
  font-weight: 600;
  font-style: italic;
}

/* Sessions List */
.sessions-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Sessions List with Timeline */
.sessions-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
  padding-left: 40px;
}

/* Creative Timeline Line */
.sessions-list::before {
  content: "";
  position: absolute;
  left: 20px;
  top: 60px;
  bottom: 20px;
  width: 3px;
  background: linear-gradient(
    to bottom,
    #4ade80 0%,
    #22c55e 30%,
    #16a34a 60%,
    #15803d 100%
  );
  border-radius: 2px;
  box-shadow: 0 0 10px rgba(76, 222, 128, 0.3);
}

.session-card {
  background: linear-gradient(
    135deg,
    rgba(26, 71, 42, 0.08) 0%,
    rgba(45, 95, 63, 0.06) 50%,
    rgba(34, 139, 34, 0.04) 100%
  );
  border-radius: 20px;
  padding: 25px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(10px);
}

/* Timeline Dots */
.session-card::before {
  content: "";
  position: absolute;
  left: -32px;
  top: 50%;
  transform: translateY(-50%);
  width: 12px;
  height: 12px;
  background: #4ade80;
  border: 3px solid rgba(26, 71, 42, 0.8);
  border-radius: 50%;
  box-shadow: 0 0 0 4px rgba(76, 222, 128, 0.2),
    0 0 15px rgba(76, 222, 128, 0.4);
  z-index: 2;
  transition: all 0.3s ease;
}

.session-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 35px rgba(76, 222, 128, 0.2);
  background: linear-gradient(
    135deg,
    rgba(26, 71, 42, 0.12) 0%,
    rgba(45, 95, 63, 0.09) 50%,
    rgba(34, 139, 34, 0.06) 100%
  );
}

.session-card:hover::before {
  width: 16px;
  height: 16px;
  box-shadow: 0 0 0 6px rgba(76, 222, 128, 0.3),
    0 0 20px rgba(76, 222, 128, 0.6);
}

/* Session Type Styling with Timeline Dots */
.session-card.featured {
  background: linear-gradient(
    135deg,
    rgba(34, 139, 34, 0.12) 0%,
    rgba(76, 222, 128, 0.08) 50%,
    rgba(22, 197, 94, 0.06) 100%
  );
}

.session-card.featured::before {
  background: linear-gradient(135deg, #4ade80, #22c55e);
  width: 14px;
  height: 14px;
  box-shadow: 0 0 0 5px rgba(76, 222, 128, 0.3),
    0 0 18px rgba(76, 222, 128, 0.5);
}

.session-card.keynote::before {
  background: linear-gradient(135deg, #f59e0b, #d97706);
  box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.3),
    0 0 15px rgba(245, 158, 11, 0.4);
}

.session-card.masterclass::before {
  background: linear-gradient(135deg, #8b5cf6, #7c3aed);
  box-shadow: 0 0 0 4px rgba(139, 92, 246, 0.3),
    0 0 15px rgba(139, 92, 246, 0.4);
}

.session-card.tour::before {
  background: linear-gradient(135deg, #06b6d4, #0891b2);
  box-shadow: 0 0 0 4px rgba(6, 182, 212, 0.3), 0 0 15px rgba(6, 182, 212, 0.4);
}

/* Session Details */
.session-time {
  display: inline-block;
  background: linear-gradient(135deg, #4ade80, #22c55e);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 15px;
  box-shadow: 0 4px 12px rgba(76, 222, 128, 0.3);
}

.session-details {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.session-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #1a472a;
  line-height: 1.3;
  margin: 0;
}

.session-description {
  color: #666;
  line-height: 1.6;
  font-size: 1rem;
  margin: 0;
}

.session-meta {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 15px;
  flex-wrap: wrap;
}

.session-location {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.95rem;
  color: #666;
  background: rgba(76, 222, 128, 0.1);
  padding: 6px 12px;
  border-radius: 15px;
}

.session-location svg {
  width: 16px;
  height: 16px;
  color: #4ade80;
}

.session-type {
  background: linear-gradient(
    135deg,
    rgba(34, 139, 34, 0.1),
    rgba(76, 222, 128, 0.1)
  );
  color: #1a472a;
  padding: 6px 12px;
  border-radius: 15px;
  font-size: 0.875rem;
  font-weight: 600;
}

/* Right Panel - Static Info & Navigation */
.agenda-info-panel {
  background: linear-gradient(
    135deg,
    rgba(26, 71, 42, 0.15) 0%,
    rgba(45, 95, 63, 0.12) 50%,
    rgba(34, 139, 34, 0.1) 100%
  );
  border-radius: 32px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  backdrop-filter: blur(20px);
  position: relative;
  height: 800px;
  display: flex;
  flex-direction: column;
}

.agenda-info-panel::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #4ade80 0%, #22c55e 100%);
}

/* Agenda Introduction */
.agenda-intro {
  padding: 40px 40px 30px;
  text-align: center;
}

.agenda-badge {
  display: inline-block;
  padding: 8px 20px;
  background: rgba(76, 222, 128, 0.2);
  border: 1px solid rgba(76, 222, 128, 0.4);
  border-radius: 25px;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 1.5px;
  margin-bottom: 20px;
  color: rgba(255, 255, 255, 0.95);
  text-transform: uppercase;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 15px rgba(76, 222, 128, 0.3);
}

.agenda-title {
  font-family: "Poppins", sans-serif;
  font-size: 2.5rem;
  font-weight: 800;
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 15px;
  line-height: 1.1;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.agenda-subtitle {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 400;
  line-height: 1.5;
  margin: 0;
}

/* Event Details */
.event-details {
  padding: 30px 40px;
  display: flex;
  flex-direction: column;
  gap: 25px;
  border-bottom: 1px solid rgba(76, 222, 128, 0.15);
}

.detail-group h4 {
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 1.5px;
  color: #4ade80;
  margin-bottom: 8px;
  text-transform: uppercase;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.detail-group p {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 600;
  line-height: 1.4;
  margin: 0;
}

/* Day Selector */
.day-selector {
  padding: 30px 40px 40px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  flex: 1;
}

.day-button {
  background: linear-gradient(
    135deg,
    rgba(26, 71, 42, 0.12) 0%,
    rgba(45, 95, 63, 0.08) 50%,
    rgba(34, 139, 34, 0.06) 100%
  );
  border-radius: 20px;
  padding: 18px 25px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(10px);
}

.day-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(76, 222, 128, 0.1),
    transparent
  );
  transition: left 0.5s ease;
}

.day-button:hover::before {
  left: 100%;
}

.day-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(76, 222, 128, 0.2);
}

.day-button.active {
  background: linear-gradient(135deg, #4ade80 0%, #22c55e 100%);
  color: white;
  transform: translateY(-3px);
  box-shadow: 0 12px 30px rgba(76, 222, 128, 0.3);
}

.day-label {
  font-weight: 700;
  font-size: 1rem;
  margin-bottom: 5px;
  letter-spacing: 0.5px;
  color: rgba(255, 255, 255, 0.95);
}

.day-short-date {
  font-size: 0.875rem;
  opacity: 0.8;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.8);
}

/* Vue Transitions */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
  transform: translateY(0);
}

/* Responsive Design */
@media (max-width: 1200px) {
  .agenda-layout {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .agenda-info-panel {
    height: auto;
    min-height: 600px;
  }

  .agenda-scroll-container {
    height: 600px;
  }
}

@media (max-width: 768px) {
  .agenda-section {
    padding: 80px 0;
  }

  .agenda-layout {
    gap: 30px;
  }

  .agenda-content-panel,
  .agenda-info-panel {
    border-radius: 20px;
  }

  .agenda-scroll-container {
    padding: 25px;
    height: 500px;
  }

  .day-header-large {
    flex-direction: column;
    text-align: center;
    gap: 15px;
  }

  .day-number-large {
    font-size: 3rem;
  }

  .day-title-large {
    font-size: 1.5rem;
  }

  .agenda-title {
    font-size: 2rem;
  }

  .agenda-intro,
  .event-details,
  .day-selector {
    padding: 25px;
  }

  .session-card {
    padding: 20px;
  }

  .session-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}

/* Responsive Design for Agenda */
@media (max-width: 768px) {
  .event-details {
    flex-direction: column;
    align-items: center;
  }

  .agenda-item {
    flex-direction: column;
  }

  .time-slot {
    min-width: 100%;
    padding: 15px;
  }

  .agenda-details {
    padding: 20px;
  }

  .day-title {
    font-size: 1.8rem;
  }

  .download-section {
    padding: 30px 20px;
  }
}


/* Pricing Section */
.pricing-section {
  padding: 80px 0;
  background: var(--color-background-light);
}

.section-subtitle {
  text-align: center;
  font-size: 1.2rem;
  color: var(--color-text-secondary);
  margin-bottom: 50px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.pricing-grid-simple {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  margin-top: 50px;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
}

.pricing-card-simple {
  background: var(--color-white);
  border: 2px solid var(--color-muted);
  border-radius: var(--radius-xl);
  padding: 30px 25px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 450px;
  height: 100%;
}

.pricing-card-simple.featured {
  border-color: var(--color-primary);
  box-shadow: 0 10px 30px rgba(74, 222, 128, 0.15);
}

.pricing-card-simple:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-xl);
}

.pricing-title-simple {
  font-size: 1.5rem;
  color: var(--color-primary-dark);
  margin-bottom: 8px;
  font-weight: bold;
  white-space: nowrap;
}

.pricing-subtitle-simple {
  font-size: 0.9rem;
  color: var(--color-text-secondary);
  margin-bottom: 25px;
}

.pricing-amount-simple {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.price-display {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.price-label {
  font-size: 0.85rem;
  color: var(--color-text-secondary);
  font-weight: 500;
  margin-top: 5px;
}

.currency-simple {
  font-size: 1.2rem;
  color: var(--color-primary);
  font-weight: bold;
}

.price-simple {
  font-size: 2.5rem;
  font-weight: bold;
  color: var(--color-primary);
}

.pricing-description {
  font-size: 0.95rem;
  color: var(--color-text-primary);
  margin-bottom: 20px;
  line-height: 1.5;
}

.additional-services {
  background: var(--color-background-light);
  border-radius: var(--radius-md);
  padding: 15px;
  margin: 20px 0;
  border: 1px solid rgba(74, 222, 128, 0.2);
  flex-grow: 1;
}

.services-title {
  font-size: 0.85rem;
  color: var(--color-primary-dark);
  font-weight: 600;
  margin: 0 0 10px 0;
  text-align: left;
}

.service-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  font-size: 0.85rem;
  color: var(--color-text-primary);
}

.service-item:last-child {
  border-bottom: none;
}

.service-price {
  color: var(--color-primary);
  font-weight: 600;
}

.btn-pricing-simple {
  background: var(--gradient-cta);
  color: white;
  border: none;
  padding: 12px 25px;
  font-size: 1rem;
  font-weight: bold;
  border-radius: var(--radius-lg);
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-top: auto;
}

.btn-pricing-simple:hover {
  background: var(--gradient-hover);
  transform: translateY(-2px);
}

.pricing-info {
  margin-top: 50px;
  text-align: center;
  padding: 30px;
  background: var(--color-white);
  border-radius: var(--radius-lg);
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.pricing-note {
  margin-bottom: 15px;
  color: var(--color-text-primary);
  line-height: 1.6;
}

.pricing-note:last-child {
  margin-bottom: 0;
}

.pricing-link {
  color: var(--color-primary);
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}

.pricing-link:hover {
  color: var(--color-primary-light);
  text-decoration: underline;
}

/* Contact Section */
.contact-section {
  padding: 80px 0;
  background: linear-gradient(
    135deg,
    var(--color-background-light) 0%,
    var(--color-white) 100%
  );
  color: var(--color-text-primary);
  border-top: 4px solid var(--color-primary);
  position: relative;
}

.contact-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--gradient-cta);
}

.contact-section .section-title {
  color: var(--color-primary-dark);
  font-size: 2.8rem;
  text-align: center;
  margin-bottom: 20px;
  font-weight: 700;
}

.contact-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  margin-top: 50px;
}

.contact-info {
  background: var(--color-white);
  padding: 40px;
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-lg);
  border: 2px solid var(--color-background-light);
}

.contact-info h3 {
  font-size: 1.5rem;
  margin-bottom: 30px;
  color: var(--color-primary);
  font-weight: 600;
}

.contact-info-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
}

.contact-info-col {
  display: flex;
  flex-direction: column;
}

.contact-item {
  margin-bottom: 25px;
}

.contact-item strong {
  display: block;
  color: var(--color-primary-dark);
  margin-bottom: 5px;
  font-size: 1.1rem;
  font-weight: 600;
}

.contact-item p {
  margin: 0;
  line-height: 1.6;
  color: var(--color-text-primary);
}

.contact-item a {
  color: var(--color-primary);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.contact-item a:hover {
  color: var(--color-primary-light);
}

.contact-description {
  background: var(--color-white);
  padding: 40px;
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-lg);
  border: 2px solid var(--color-background-light);
}

.contact-description h3 {
  font-size: 1.5rem;
  margin-bottom: 30px;
  color: var(--color-primary-dark);
}

.contact-description p {
  line-height: 1.8;
  font-size: 1.1rem;
  color: var(--color-text-primary);
  margin: 0;
}

.contact-about-text {
  margin-top: 30px !important;
  padding-top: 24px;
  border-top: 1px solid var(--color-background-light);
}

/* Responsive Design */
@media (max-width: 1200px) {
  .pricing-grid-simple {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
    max-width: 800px;
  }
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 2.5rem;
  }

  .hero-date {
    font-size: 1.8rem;
  }

  .hero-venue {
    font-size: 1.2rem;
  }

  .countdown-timer {
    gap: 15px;
  }

  .countdown-item {
    padding: 15px 10px;
    min-width: 60px;
  }

  .countdown-number {
    font-size: 1.8rem;
  }

  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .feature-row {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .expectations-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .expectations-title {
    font-size: 1.5rem;
  }

  .impact-section {
    padding: 30px 20px;
  }

  .impact-title {
    font-size: 1.5rem;
  }

  .impact-text {
    font-size: 1rem;
  }


  .pricing-grid-simple {
    grid-template-columns: 1fr;
    gap: 20px;
    max-width: 400px;
  }

  .pricing-card.featured {
    transform: none;
  }

  .contact-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .contact-info,
  .contact-description {
    padding: 30px 20px;
  }

  .contact-info-columns {
    grid-template-columns: 1fr;
  }

  .agenda-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .time {
    min-width: auto;
  }
}

.venue-location {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}

.venue-location div {
  margin: 0;
}

.venue-inline {
  font-weight: inherit;
}

.location-strong {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.location-strong .venue-location {
  font-weight: normal;
}

/* ============================================================
   About Section — redesigned (editorial, light-green)
   Matches the hero's Playfair + Inter palette
   ============================================================ */
.ahrs-about {
  position: relative;
  padding: clamp(72px, 9vw, 140px) 0;
  overflow: hidden;
  z-index: 2;
  width: 100%;
}
.ahrs-about-wrap {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0 clamp(24px, 3vw, 56px);
}

/* Header */
.ahrs-about-header {
  margin-bottom: clamp(48px, 6vw, 88px);
  max-width: 880px;
}
.ahrs-about-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 8px 18px 8px 14px;
  border: 1px solid rgba(17, 149, 73, 0.28);
  border-radius: 100px;
  background: rgba(17, 149, 73, 0.06);
  font-family: "Inter", "Segoe UI", sans-serif;
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: #0c6e37;
  margin-bottom: 26px;
}
.ahrs-about-eyebrow .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #16a85a;
  box-shadow: 0 0 0 4px rgba(22, 168, 90, 0.18);
}
.ahrs-about-title {
  font-family: "Playfair Display", "Times New Roman", serif;
  font-weight: 600;
  font-size: clamp(40px, 5.4vw, 76px);
  line-height: 1.08;
  letter-spacing: -0.018em;
  color: #0a3a1f;
  margin: 0;
}
.ahrs-about-italic {
  font-style: italic;
  font-weight: 500;
  color: #119549;
}

/* Body grid */
.ahrs-about-body {
  display: grid;
  grid-template-columns: 1.45fr 1fr;
  gap: clamp(36px, 5vw, 80px);
  margin-bottom: clamp(54px, 6vw, 96px);
  align-items: start;
}

/* Left column */
.ahrs-about-summit-line {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 14px;
  margin-bottom: 26px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(17, 149, 73, 0.18);
}
.ahrs-about-summit-name {
  font-family: "Playfair Display", "Times New Roman", serif;
  font-style: italic;
  font-weight: 500;
  font-size: clamp(24px, 2.4vw, 32px);
  line-height: 1.15;
  color: #0a3a1f;
}
.ahrs-about-summit-acro {
  font-family: "Inter", "Segoe UI", sans-serif;
  font-size: 12.5px;
  font-weight: 700;
  letter-spacing: 0.3em;
  color: #0c6e37;
  padding: 6px 12px;
  border: 1px solid rgba(17, 149, 73, 0.35);
  border-radius: 4px;
  background: rgba(17, 149, 73, 0.05);
}
.ahrs-about-lede {
  font-family: "Inter", "Segoe UI", sans-serif;
  font-weight: 400;
  font-size: clamp(18px, 1.5vw, 22px);
  line-height: 1.6;
  color: #2a3d33;
  margin: 0 0 36px;
  max-width: 640px;
}
.ahrs-about-lede strong {
  font-weight: 600;
  color: #0c6e37;
}

.ahrs-about-theme-card {
  padding: 26px 30px;
  background: #ffffff;
  border-left: 3px solid #119549;
  border-radius: 4px 14px 14px 4px;
  box-shadow: 0 6px 22px rgba(17, 149, 73, 0.07);
}
.ahrs-about-theme-label {
  font-family: "Inter", "Segoe UI", sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: #0c6e37;
  margin-bottom: 12px;
}
.ahrs-about-theme-quote {
  font-family: "Playfair Display", "Times New Roman", serif;
  font-style: italic;
  font-weight: 500;
  font-size: clamp(22px, 2vw, 30px);
  line-height: 1.35;
  color: #0a3a1f;
  margin: 0;
}

/* Right column */
.ahrs-about-details {
  background: #ffffff;
  border: 1px solid rgba(17, 149, 73, 0.16);
  border-radius: 18px;
  padding: 28px 30px;
  box-shadow: 0 10px 32px rgba(17, 149, 73, 0.07);
}
.ahrs-about-details-head {
  font-family: "Inter", "Segoe UI", sans-serif;
  font-size: 12.5px;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: #0c6e37;
  padding-bottom: 20px;
  margin-bottom: 24px;
  border-bottom: 1px solid rgba(17, 149, 73, 0.15);
}
.ahrs-about-detail-list {
  display: flex;
  flex-direction: column;
  gap: 22px;
  margin: 0;
}
.ahrs-about-detail {
  display: flex;
  gap: 14px;
  align-items: flex-start;
}
.ahrs-about-detail-icon {
  width: 46px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(17, 149, 73, 0.09);
  flex: none;
}
.ahrs-about-detail-icon svg {
  width: 22px;
  height: 22px;
  stroke: #119549;
}
.ahrs-about-detail dt {
  font-family: "Inter", "Segoe UI", sans-serif;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #6f8a79;
  margin-bottom: 6px;
}
.ahrs-about-detail dd {
  font-family: "Inter", "Segoe UI", sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
  color: #0a3a1f;
  margin: 0;
}

/* Stat strip */
.ahrs-about-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: clamp(20px, 3vw, 36px);
  padding-top: 38px;
  border-top: 1px solid rgba(17, 149, 73, 0.18);
}
.ahrs-about-stat {
  text-align: left;
}
.ahrs-about-stat-n {
  display: block;
  font-family: "Playfair Display", "Times New Roman", serif;
  font-size: clamp(44px, 4.8vw, 68px);
  font-weight: 600;
  line-height: 1;
  letter-spacing: -0.015em;
  font-variant-numeric: tabular-nums;
  color: #0a3a1f;
  margin-bottom: 10px;
}
.ahrs-about-stat-l {
  display: block;
  font-family: "Inter", "Segoe UI", sans-serif;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #6f8a79;
}

/* Responsive */
@media (max-width: 900px) {
  .ahrs-about-body {
    grid-template-columns: 1fr;
    gap: 36px;
  }
  .ahrs-about-stats {
    grid-template-columns: repeat(2, 1fr);
    gap: 28px;
  }
}
@media (max-width: 480px) {
  .ahrs-about-summit-line {
    gap: 10px;
  }
  .ahrs-about-stats {
    gap: 22px;
  }
  .ahrs-about-stat-n {
    font-size: 40px;
  }
  .ahrs-about-stat-l {
    font-size: 11px;
  }
  .ahrs-about-details {
    padding: 22px 22px;
  }
  .ahrs-about-detail dd {
    font-size: 16px;
  }
}

/* ============================================================
   Editorial Section Header — reused across Objectives, Themes,
   Partners, and Pricing (matches the About section's typography
   while leaving the existing section backgrounds untouched).
   ============================================================ */
.ahrs-editorial .ahrs-section-header {
  max-width: 880px;
  margin: 0 auto clamp(40px, 5vw, 72px);
  text-align: center;
}
.ahrs-editorial .ahrs-section-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 8px 18px 8px 14px;
  border: 1px solid rgba(17, 149, 73, 0.28);
  border-radius: 100px;
  background: rgba(17, 149, 73, 0.06);
  font-family: "Inter", "Segoe UI", sans-serif;
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: #0c6e37;
  margin-bottom: 22px;
}
.ahrs-editorial .ahrs-section-eyebrow .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #16a85a;
  box-shadow: 0 0 0 4px rgba(22, 168, 90, 0.18);
}
.ahrs-editorial .ahrs-section-title {
  font-family: "Playfair Display", "Times New Roman", serif;
  font-weight: 600;
  font-size: clamp(34px, 4.4vw, 64px);
  line-height: 1.1;
  letter-spacing: -0.018em;
  color: #0a3a1f;
  margin: 0;
}
.ahrs-editorial .ahrs-section-italic {
  font-style: italic;
  font-weight: 500;
  color: #119549;
}
.ahrs-editorial .ahrs-section-lede {
  font-family: "Inter", "Segoe UI", sans-serif;
  font-weight: 400;
  font-size: clamp(16px, 1.3vw, 19px);
  line-height: 1.6;
  color: #2a3d33;
  margin: 22px auto 0;
  max-width: 640px;
}

/* ============================================================
   Objective cards — editorial typography overrides
   (keep existing card layout/background)
   ============================================================ */
.ahrs-editorial.objectives-section .objective-card {
  text-align: left;
}
.ahrs-editorial.objectives-section .objective-icon {
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(17, 149, 73, 0.09);
  margin-bottom: 22px;
}
.ahrs-editorial.objectives-section .objective-icon svg {
  width: 24px;
  height: 24px;
  stroke: #119549;
  stroke-width: 1.8;
}
.ahrs-editorial.objectives-section .objective-title {
  font-family: "Playfair Display", "Times New Roman", serif !important;
  font-weight: 600 !important;
  font-size: clamp(22px, 1.8vw, 28px) !important;
  line-height: 1.2 !important;
  letter-spacing: -0.01em !important;
  color: #0a3a1f !important;
  margin-bottom: 12px !important;
  background: none !important;
  -webkit-text-fill-color: #0a3a1f !important;
}
.ahrs-editorial.objectives-section .objective-text {
  font-family: "Inter", "Segoe UI", sans-serif !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 1.6 !important;
  color: #2a3d33 !important;
}
.ahrs-editorial.objectives-section .impact-title {
  font-size: clamp(28px, 3vw, 42px) !important;
  font-weight: 700 !important;
  margin-bottom: 18px !important;
}

/* ============================================================
   Theme cards — editorial typography overrides
   ============================================================ */
.ahrs-editorial.themes-section .theme-card {
  text-align: left;
}
.ahrs-editorial.themes-section .theme-card h3 {
  font-family: "Playfair Display", "Times New Roman", serif !important;
  font-weight: 600 !important;
  font-size: clamp(20px, 1.7vw, 26px) !important;
  line-height: 1.22 !important;
  letter-spacing: -0.01em !important;
  color: #0a3a1f !important;
  margin-bottom: 14px !important;
  background: none !important;
  -webkit-text-fill-color: #0a3a1f !important;
}
.ahrs-editorial.themes-section .theme-card p {
  font-family: "Inter", "Segoe UI", sans-serif !important;
  font-weight: 400 !important;
  font-size: 15.5px !important;
  line-height: 1.6 !important;
  color: #2a3d33 !important;
  margin-bottom: 18px !important;
}
.ahrs-editorial.themes-section .theme-highlights {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.ahrs-editorial.themes-section .theme-highlights .highlight {
  font-family: "Inter", "Segoe UI", sans-serif !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  letter-spacing: 0.16em !important;
  text-transform: uppercase !important;
  color: #0c6e37 !important;
  background: rgba(17, 149, 73, 0.08) !important;
  border: 1px solid rgba(17, 149, 73, 0.22) !important;
  padding: 6px 12px !important;
  border-radius: 100px !important;
}

/* ============================================================
   Partners section — editorial typography overrides
   ============================================================ */
.ahrs-editorial.partners-section .partners-teaser {
  text-align: center;
  max-width: 720px;
  margin: 0 auto;
}
.ahrs-editorial.partners-section .partners-count {
  font-family: "Playfair Display", "Times New Roman", serif !important;
  font-style: italic !important;
  font-weight: 500 !important;
  font-size: clamp(20px, 1.8vw, 28px) !important;
  line-height: 1.35 !important;
  color: #0a3a1f !important;
  margin-bottom: 28px !important;
}
.ahrs-editorial.partners-section .btn-partners {
  display: inline-flex !important;
  align-items: center !important;
  gap: 10px !important;
  background: #119549 !important;
  color: #ffffff !important;
  font-family: "Inter", "Segoe UI", sans-serif !important;
  font-size: 16.5px !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
  padding: 15px 30px !important;
  border: 1px solid transparent !important;
  border-radius: 100px !important;
  text-decoration: none !important;
  box-shadow: 0 12px 32px -10px rgba(17, 149, 73, 0.65) !important;
  transition: transform 0.3s, box-shadow 0.3s, background 0.3s !important;
}
.ahrs-editorial.partners-section .btn-partners:hover {
  background: #16a85a !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 18px 42px -10px rgba(22, 168, 90, 0.75) !important;
  color: #ffffff !important;
}
.ahrs-editorial.partners-section .btn-partners svg {
  width: 18px;
  height: 18px;
  transition: transform 0.3s;
}
.ahrs-editorial.partners-section .btn-partners:hover svg {
  transform: translateX(4px);
}

/* ============================================================
   Pricing cards — editorial typography overrides
   ============================================================ */
.ahrs-editorial.pricing-section .pricing-card-simple {
  text-align: left;
}
.ahrs-editorial.pricing-section .pricing-title-simple {
  font-family: "Playfair Display", "Times New Roman", serif !important;
  font-weight: 600 !important;
  font-size: clamp(20px, 1.8vw, 26px) !important;
  line-height: 1.2 !important;
  letter-spacing: -0.01em !important;
  color: #0a3a1f !important;
  margin-bottom: 4px !important;
  background: none !important;
  -webkit-text-fill-color: #0a3a1f !important;
}
.ahrs-editorial.pricing-section .pricing-subtitle-simple {
  font-family: "Inter", "Segoe UI", sans-serif !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  letter-spacing: 0.22em !important;
  text-transform: uppercase !important;
  color: #0c6e37 !important;
  margin-bottom: 22px !important;
}
.ahrs-editorial.pricing-section .pricing-amount-simple {
  margin-bottom: 18px;
}
.ahrs-editorial.pricing-section .price-display {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 4px;
}
.ahrs-editorial.pricing-section .currency-simple {
  font-family: "Inter", "Segoe UI", sans-serif !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  letter-spacing: 0.12em !important;
  color: #0c6e37 !important;
}
.ahrs-editorial.pricing-section .price-simple {
  font-family: "Playfair Display", "Times New Roman", serif !important;
  font-weight: 600 !important;
  font-size: clamp(36px, 3.6vw, 52px) !important;
  line-height: 1 !important;
  letter-spacing: -0.015em !important;
  color: #0a3a1f !important;
  font-variant-numeric: tabular-nums !important;
  background: none !important;
  -webkit-text-fill-color: #0a3a1f !important;
}
.ahrs-editorial.pricing-section .price-label {
  font-family: "Inter", "Segoe UI", sans-serif !important;
  font-size: 10.5px !important;
  font-weight: 600 !important;
  letter-spacing: 0.2em !important;
  text-transform: uppercase !important;
  color: #6f8a79 !important;
}
.ahrs-editorial.pricing-section .pricing-description {
  font-family: "Inter", "Segoe UI", sans-serif !important;
  font-size: 14.5px !important;
  font-weight: 400 !important;
  line-height: 1.55 !important;
  color: #2a3d33 !important;
  margin-bottom: 22px !important;
}
.ahrs-editorial.pricing-section .additional-services {
  border-top: 1px solid rgba(17, 149, 73, 0.18);
  padding-top: 16px;
  margin-bottom: 24px;
}
.ahrs-editorial.pricing-section .service-item {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 8px 0;
  font-family: "Inter", "Segoe UI", sans-serif !important;
  font-size: 13.5px !important;
  font-weight: 500 !important;
  color: #2a3d33 !important;
}
.ahrs-editorial.pricing-section .service-item + .service-item {
  border-top: 1px dashed rgba(17, 149, 73, 0.18);
}
.ahrs-editorial.pricing-section .service-price {
  font-weight: 700 !important;
  color: #0a3a1f !important;
  font-variant-numeric: tabular-nums;
}
.ahrs-editorial.pricing-section .btn-pricing-simple {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  width: 100% !important;
  background: #119549 !important;
  color: #ffffff !important;
  font-family: "Inter", "Segoe UI", sans-serif !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  letter-spacing: 0.16em !important;
  text-transform: uppercase !important;
  padding: 14px 24px !important;
  border: 1px solid transparent !important;
  border-radius: 100px !important;
  cursor: pointer !important;
  box-shadow: 0 12px 32px -10px rgba(17, 149, 73, 0.5) !important;
  transition: transform 0.3s, box-shadow 0.3s, background 0.3s !important;
}
.ahrs-editorial.pricing-section .btn-pricing-simple:hover {
  background: #16a85a !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 18px 42px -10px rgba(22, 168, 90, 0.65) !important;
}
.ahrs-editorial.pricing-section .pricing-card-simple.featured {
  position: relative;
}
.ahrs-editorial.pricing-section .pricing-card-simple.featured::before {
  content: "";
  position: absolute;
  left: 0;
  top: 18px;
  bottom: 18px;
  width: 3px;
  background: #119549;
  border-radius: 0 4px 4px 0;
}
.ahrs-editorial.pricing-section .pricing-info {
  text-align: center;
  margin-top: clamp(36px, 4vw, 56px);
}
.ahrs-editorial.pricing-section .pricing-note {
  font-family: "Inter", "Segoe UI", sans-serif !important;
  font-size: 15px !important;
  color: #2a3d33 !important;
}
.ahrs-editorial.pricing-section .pricing-link {
  color: #0c6e37 !important;
  font-weight: 600 !important;
  text-decoration: underline !important;
  text-underline-offset: 3px !important;
  text-decoration-thickness: 1px !important;
}
.ahrs-editorial.pricing-section .pricing-link:hover {
  color: #119549 !important;
}

@media (max-width: 760px) {
  .ahrs-editorial .ahrs-section-header {
    text-align: left;
  }
  .ahrs-editorial .ahrs-section-lede {
    margin-left: 0;
    margin-right: 0;
  }
}

</style>
